<template>
  <v-container max-width="100%" style="margin-top: 2%">
    <LoadingComponent
      :loading="loading"
      :message="loadingMessage"
      style="z-index: 1000"
    ></LoadingComponent>
    <template>
      <v-row justify="center">
        <v-dialog
          v-model="confirmDialog"
          persistent
          max-width="500"
          style="border-radius: 10px"
        >
          <v-card>
            <v-card-title class="headline">
              <span style="color: #d60000">{{ $t("system.alert") }}</span>
            </v-card-title>
            <v-card-text>
              <span style="color: #d60000">{{ this.mensagemdialog }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="red accent-4"
                class="white--text"
                @click="closeConfirmDialog"
                >{{ this.messageDismissButton }}</v-btn
              >
              <v-btn
                v-if="showConfirmButton"
                color="red accent-4"
                class="white--text"
                @click="deleteFromDatabase"
                >{{ this.messageConfirmButton }}</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <v-dialog v-model="dialogResultIntegracaoSSFF" max-width="80%">
      <v-card>
        <v-card-title>
          <span>{{ $t("passengers.passengerData") }}</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="12" md="6">
              <v-text-field
                v-model="passageiroIntegracao.nome_completo"
                :label="$t('passengers.personal.name')"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field
                v-model="passageiroIntegracao.cpf"
                :label="$t('passengers.personal.cpf')"
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="6">
              <v-text-field
                v-model="passageiroIntegracao.email"
                :label="$t('passengers.personal.email')"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field
                v-model="passageiroIntegracao.telefone"
                :label="$t('passengers.personal.phone')"
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                v-model="passageiroIntegracao.matricula"
                :label="$t('passengers.personal.registrationCode')"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                v-model="passageiroIntegracao.cod_cargo"
                :label="$t('passengers.personal.jobPositionCode')"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                v-model="passageiroIntegracao.cod_integracao_turno"
                :label="$t('passengers.personal.shiftIntegrationCode')"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                v-model="passageiroIntegracao.cod_turno"
                :label="$t('passengers.personal.shiftCode')"
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="passageiroIntegracao.descricao_unidade"
                :label="$t('passengers.personal.unitDescription')"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="passageiroIntegracao.cod_unidade"
                :label="$t('passengers.personal.unitIntegrationCode')"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="passageiroIntegracao.cod_integracao_unidade"
                :label="$t('passengers.personal.unitIntegrationCode')"
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                v-model="passageiroIntegracao.cep"
                :label="$t('passengers.address.cep')"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="5">
              <v-text-field
                v-model="passageiroIntegracao.endereco"
                :label="$t('passengers.address.street')"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="2">
              <v-text-field
                v-model="passageiroIntegracao.numero"
                :label="$t('passengers.address.number')"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="2">
              <v-text-field
                v-model="passageiroIntegracao.complemento"
                :label="$t('passengers.address.complement')"
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                v-model="passageiroIntegracao.cidade"
                :label="$t('passengers.address.city')"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                v-model="passageiroIntegracao.estado"
                :label="$t('passengers.address.state')"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                v-model="passageiroIntegracao.sigla_pais"
                :label="$t('passengers.address.country')"
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="4">
              <v-autocomplete
                v-model="passageiroIntegracao.id_cliente"
                :label="$t('passengers.personal.client')"
                item-value="id_cliente"
                item-text="nome_cliente"
                :items="clientes"
                :disabled="isPassageiroIntegracaoClienteDisabled"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="2">
              <LazySelect
                ref="linhaIdaIntegracaoSelect"
                get-url="getLinhaslazy"
                text="cod_linha"
                value="id_linha"
                :label="$t('passengers.personal.lineOutbound')"
                @input="onLinhaIdaIntegracaoSelect"
              />
            </v-col>
            <v-col cols="12" sm="12" md="2">
              <LazySelect
                ref="linhaVoltaIntegracaoSelect"
                get-url="getLinhaslazy"
                text="cod_linha"
                value="id_linha"
                :label="$t('passengers.personal.lineInbound')"
                @input="onLinhaVoltaIntegracaoSelect"
              />
            </v-col>
            <v-col cols="12" sm="12" md="4">
              <v-autocomplete
                v-model="passageiroIntegracao.id_grupo"
                :label="$t('passengers.personal.group')"
                item-value="id_grupo"
                item-text="nome"
                :items="grupos"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="closeDialogResultIntegracaoSSFF">{{
            $t("button.cancel")
          }}</v-btn>
          <v-btn color="primary" @click="savePassengerIntegration">{{
            $t("button.add")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="errosDialog" max-width="60%" style="border-radius: 10px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="errosDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{
            $t("passengers.errors.sendToIntegration")
          }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-list max-heigh="50vh" class="overflow-y-auto">
            <v-list-item
              v-for="(erro, e) in errosEnvio"
              :key="`ERRO-${e}`"
              two-line
            >
              <v-list-item-content>
                <v-list-item-title>{{
                  erro.descricao_tipo_erro
                }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  erro.nome_equipamento
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>

    <ResultDialogZIP
      :show="zipResultDialog"
      :result="zipResult"
      :token="token"
      @close="zipResultDialog = false"
    />
    <ResultDialogCSV
      :show="showResultDeleteDialog"
      :result="csvResultDelete"
      :token="token"
      :headers="headersCSVDelete"
      @close="showResultDeleteDialog = false"
      @save="saveBulkDelete"
    />
    <ResultDialogCSV
      :show="showResultGoogleSheetsDialog"
      :result="csvResultGoogleSheets"
      :token="token"
      :headers="headersCSV"
      @close="closeResultGoogleSheetsDialog"
      @save="saveBulk"
    />
    <QrCodeSendResultDialog
      :show="qrCodeSendResultDialog"
      :results="qrCodeSendResults"
      :summary="qrCodeSendSummary"
      @close="qrCodeSendResultDialog = false"
    />

    <merus-data-table
      :headers="headers"
      :items="pessoas"
      :mostrar-inativos="mostrarInativos"
      :loading="loadingtable"
      :default-multi-sort="defaultSort"
      :loading-text="$t('passengers.loadingPeople')"
      :show-select="true"
      ref="tabelaPassageiros"
      v-model="selectedPessoas"
      item-key="id_pessoa"
      :server-items-length="totalPessoas"
      :items-per-page="numberOfRows"
      :items-per-page-last-option="itemsPerPageLastOption"
      :server-sort-by="serverSortBy"
      :server-sort-desc="serverSortDesc"
      fixed-header
      cod-tabela="PASSAGEIROS"
      append-actions
      actions-i18n-key="system.tables.passengers.headers.acoes"
      @update:headers="headers = $event"
      @update:options="onTableOptions"
      @update:filters="onFiltersUpdate"
    >
      <template v-slot:toolbar>
        <CadastroToolbar
          :title="$t('passengers.title')"
          :token="token"
          :items="pessoas"
          :load-items-for-export="loadItemsForExport"
          background-export
          list-endpoint="getallpessoas"
          :export-filters="searchFilters"
          :request-params="exportRequestParams"
          :export-sort-by="serverSortBy"
          :export-sort-desc="serverSortDesc"
          :export-total="totalPessoas"
          :selected-ids="selectedPessoasIds"
          id-field="id_pessoa"
          :csv-title="$t('passengers.title')"
          :csv-headers="headersCSV"
          :pdf-title="$t('passengers.pdfTitle')"
          :pdf-headers="headers"
          pdf-filename="passageiros"
          :help-dialog-csv-fields="helpCSV"
          :help-dialog-csv-model="$t('passengers.pdfTitle')"
          :csv-export-formats="csvExportFormats"
          :endpoint-upload-csv="canEdit || canInsert ? '/api/v1.0/processacsvpessoas/' : null"
          @saveBulk="saveBulk"
          hide-search
        >
          <template v-slot:extension>
            <v-switch
              v-model="mostrarInativos"
              :label="$t('crudVeiculos.showInactive')"
              class="ml-3 mr-4"
              hide-details
            ></v-switch>
            <v-switch
              v-if="canIntegrate || canResolveSsff"
              v-model="somentePendenciaSsff"
              :label="$t('passengers.ssffPending.filter')"
              color="warning"
              class="mr-4"
              hide-details
            ></v-switch>

            <v-tooltip top v-show="canSendQrCode">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="#4a4a4a"
                  dark
                  small
                  class="mb-2 mr-2"
                  v-bind="attrs"
                  v-on="on"
                  fab
                  @click="sendQrCodeToSelected"
                >
                  <v-icon>mdi-qrcode</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("passengers.sendQR") }}</span>
            </v-tooltip>

            <v-tooltip top>
              <template
                v-slot:activator="{ on: onTooltip, attrs: attrsTooltip }"
              >
                <v-dialog v-model="dialogFindInDatabase" max-width="80%">
                  <template
                    v-slot:activator="{ on: onDialog, attrs: attrsDialog }"
                  >
                    <v-btn
                      color="#4a4a4a"
                      dark
                      small
                      class="mb-2 mr-2"
                      v-bind="{ ...attrsTooltip, ...attrsDialog }"
                      v-on="{ ...onTooltip, ...onDialog }"
                      fab
                    >
                      <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                  </template>
                  <v-card>
                    <v-toolbar dark color="primary">
                      <v-btn icon dark @click="closeDialogFindInDatabase">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-toolbar-title>{{
                        $t("passengers.findInDatabase")
                      }}</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                      <v-form
                        ref="formFindInDatabase"
                        v-model="formFindInDatabaseValidado"
                      >
                        <v-row>
                          <v-col cols="12" sm="12" md="6">
                            <v-text-field
                              v-model="docToSearch"
                              :label="$t('passengers.personal.cpf')"
                              :rules="[addByIntegrationDocRules]"
                              @input="onIntegracaoSSFFFieldChange"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="12" md="6">
                            <v-text-field
                              v-model="emailToSearch"
                              :label="$t('passengers.personal.email')"
                              :rules="[addByIntegrationEmailRules]"
                              @input="onIntegracaoSSFFFieldChange"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" @click="searchInDatabase">{{
                        $t("button.search")
                      }}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <span>{{ $t("passengers.findInDatabase") }}</span>
            </v-tooltip>

            <v-tooltip top>
              <template
                v-slot:activator="{ on: onTooltip, attrs: attrsTooltip }"
              >
                <v-dialog v-model="dialogGoogleSheetsImport" max-width="560">
                  <template
                    v-slot:activator="{ on: onDialog, attrs: attrsDialog }"
                  >
                    <v-btn
                      color="#4a4a4a"
                      dark
                      small
                      class="mb-2 mr-2"
                      v-bind="{ ...attrsTooltip, ...attrsDialog }"
                      v-on="{ ...onTooltip, ...onDialog }"
                      fab
                    >
                      <v-icon>mdi-google-spreadsheet</v-icon>
                    </v-btn>
                  </template>
                  <v-card>
                    <v-toolbar dark color="primary">
                      <v-btn
                        icon
                        dark
                        @click="
                          dialogGoogleSheetsImport = false;
                          googleSheetsUrl = '';
                        "
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-toolbar-title>{{
                        $t("passengers.googleSheetsImport.title")
                      }}</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text class="pt-4">
                      <v-text-field
                        v-model="googleSheetsUrl"
                        :label="$t('passengers.googleSheetsImport.urlLabel')"
                        :hint="$t('passengers.googleSheetsImport.urlHint')"
                        persistent-hint
                        clearable
                        autofocus
                      />
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        text
                        @click="
                          dialogGoogleSheetsImport = false;
                          googleSheetsUrl = '';
                        "
                        >{{ $t("button.cancel") }}</v-btn
                      >
                      <v-btn
                        color="primary"
                        :loading="loadingGoogleSheetsImport"
                        :disabled="loadingGoogleSheetsImport"
                        @click="submitGoogleSheetsImport"
                      >
                        {{ $t("passengers.googleSheetsImport.import") }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <span>{{ $t("passengers.googleSheetsImport.tooltip") }}</span>
            </v-tooltip>

            <v-tooltip top v-if="canInsert && canIntegrate">
              <template
                v-slot:activator="{ on: onTooltip, attrs: attrsTooltip }"
              >
                <v-dialog v-model="dialogIntegracaoSSFF" max-width="80%">
                  <template
                    v-slot:activator="{ on: onDialog, attrs: attrsDialog }"
                  >
                    <v-btn
                      color="#4a4a4a"
                      dark
                      small
                      class="mb-2 mr-2"
                      v-bind="{ ...attrsTooltip, ...attrsDialog }"
                      v-on="{ ...onTooltip, ...onDialog }"
                      fab
                    >
                      <v-icon>mdi-magnify-plus</v-icon>
                    </v-btn>
                  </template>
                  <v-card>
                    <v-toolbar dark color="primary">
                      <v-btn icon dark @click="dialogIntegracaoSSFF = false">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-toolbar-title>{{
                        $t("passengers.addByIntegration")
                      }}</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                      <v-form
                        ref="formIntegracaoSSFF"
                        v-model="formIntegracaoSSFFValidado"
                      >
                        <v-row>
                          <v-col cols="12" sm="12" md="6">
                            <v-text-field
                              v-model="docToSearch"
                              :label="$t('passengers.personal.cpf')"
                              :rules="[addByIntegrationDocRules]"
                              @input="onIntegracaoSSFFFieldChange"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="12" md="6">
                            <v-text-field
                              v-model="emailToSearch"
                              :label="$t('passengers.personal.email')"
                              :rules="[addByIntegrationEmailRules]"
                              @input="onIntegracaoSSFFFieldChange"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        @click="searchEmployeeByDocument"
                        >{{ $t("button.search") }}</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <span>{{ $t("passengers.addByIntegration") }}</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <UploadDialog
                  :token="token"
                  :endpoint="'/api/v1.0/processacsvdeletepessoas/'"
                  :user="user.id_usuario"
                  fileType="csv"
                  size="s"
                  icon="mdi-delete"
                  @done="handleDoneDelete"
                  @error="handleErrorDelete"
                  v-bind="attrs"
                  v-on="on"
                  :title="$t('passengers.deleteAll')"
                />
              </template>
              <span>{{ $t("passengers.deleteAll") }}</span>
            </v-tooltip>

            <!-- CSV Upload - Only for CSV files, NOT for photos -->
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <UploadDialog
                  :token="token"
                  :endpoint="'/api/v1.0/insertpessoaszip'"
                  :user="user.id_usuario"
                  fileType="zip"
                  size="s"
                  icon="mdi-zip-box"
                  @done="handleDone"
                  @error="handleError"
                  v-bind="attrs"
                  v-on="on"
                  :title="$t('passengers.uploadZipFile')"
                />
              </template>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="#4a4a4a"
                  dark
                  small
                  class="mb-2 mr-2"
                  fab
                  v-on="on"
                  @click="atualizaIntegracaoFaceid(selectedPessoas, true)"
                >
                  <v-icon>mdi-lock-open</v-icon>
                </v-btn>
              </template>
              <div>{{ $t("passengers.authorizeAll") }}</div>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="#4a4a4a"
                  dark
                  small
                  class="mb-2 mr-2"
                  fab
                  v-on="on"
                  @click="atualizaIntegracaoFaceid(selectedPessoas, false)"
                >
                  <v-icon>mdi-lock</v-icon>
                </v-btn>
              </template>
              <div>{{ $t("passengers.unauthorizeAll") }}</div>
            </v-tooltip>
            <v-tooltip top v-if="arquivoLogBulk">
              <template v-slot:activator="{ on }">
                <v-btn
                  color="orange"
                  dark
                  small
                  class="mb-2 mr-2"
                  fab
                  v-on="on"
                  @click="downloadLogBulk"
                >
                  <v-icon>mdi-download</v-icon>
                </v-btn>
              </template>
              <div>{{ $t("passengers.downloadErrorLog") }}</div>
            </v-tooltip>
          </template>
          <template v-slot:add v-if="canInsert">
            <v-dialog v-model="dialog" max-width="100%" fullscreen persistent>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="#4a4a4a"
                  dark
                  small
                  class="mb-2 mr-2"
                  v-bind="attrs"
                  v-on="on"
                  fab
                  v-show="!cadastroDisabled"
                  :disabled="cadastroDisabled"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-toolbar
                  dark
                  :color="editedItem.deletado == 1 ? 'error' : 'primary'"
                >
                  <v-btn icon dark @click="close">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <h4
                    class="text-white font-weight-bold mr-3 text-uppercase"
                    v-if="editedItem.deletado == 1"
                  >
                    {{ $t("passengers.deleted") }}
                  </h4>

                  <template v-slot:extension>
                    <v-tabs v-model="tab" align-with-title>
                      <v-tab
                        v-for="item in tabs"
                        :key="item.text"
                        v-show="!item.disabled"
                      >
                        {{ item.text }}
                      </v-tab>
                    </v-tabs>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                      <v-btn
                        dark
                        text
                        v-if="editedItem.deletado == 1"
                        @click="restaurarPessoa"
                        >{{ $t("button.restore") }}</v-btn
                      >
                      <v-btn dark text @click="save">{{
                        $t("button.save")
                      }}</v-btn>
                    </v-toolbar-items>
                  </template>
                </v-toolbar>

                <v-card-text>
                  <v-alert
                    v-if="editedItem.id_pendencia_ssff"
                    :type="editedItem.pendencia_ssff_desativada == 1 ? 'error' : 'warning'"
                    icon="mdi-alert"
                    prominent
                    text
                    class="mt-4 mb-0"
                  >
                    <div class="font-weight-bold">
                      {{ $t("passengers.ssffPending.title") }}
                    </div>
                    <div v-for="linha in linhasPendenciaSsff(editedItem)" :key="linha">
                      {{ linha }}
                    </div>
                    <div class="mt-1">{{ $t("passengers.ssffPending.hint") }}</div>
                    <template v-if="canResolveSsff" v-slot:append>
                      <v-btn
                        :color="editedItem.pendencia_ssff_desativada == 1 ? 'error' : 'warning'"
                        outlined
                        @click="abrirResolverPendenciaSsff"
                        >{{ $t("passengers.ssffPending.resolve") }}</v-btn
                      >
                    </template>
                  </v-alert>
                  <v-dialog v-model="dialogResolverSsff" max-width="520">
                    <v-card>
                      <v-card-title>{{ $t("passengers.ssffPending.resolveTitle") }}</v-card-title>
                      <v-card-text>
                        <p>{{ $t("passengers.ssffPending.resolveText") }}</p>
                        <v-textarea
                          v-model="observacaoResolverSsff"
                          :label="$t('passengers.ssffPending.observation')"
                          counter="500"
                          maxlength="500"
                          rows="3"
                          outlined
                          hide-details="auto"
                        ></v-textarea>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="dialogResolverSsff = false">{{
                          $t("button.cancel")
                        }}</v-btn>
                        <v-btn
                          color="primary"
                          :loading="resolvendoSsff"
                          @click="resolverPendenciaSsff"
                          >{{ $t("passengers.ssffPending.resolve") }}</v-btn
                        >
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-container v-show="tab === 0">
                    <v-form ref="formPessoal" v-model="formPessoalValidado">
                      <v-row>
                        <v-col cols="12" sm="4" md="4">
                          <v-text-field
                            v-model="editedItem.nome"
                            :label="$t('passengers.personal.name')"
                            :rules="[
                              (v) =>
                                !!v || $t('passengers.personal.nameRequired'),
                            ]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                          <v-text-field
                            v-model="editedItem.sobrenome"
                            :label="$t('passengers.personal.familyName')"
                            :rules="[
                              (v) =>
                                !!v ||
                                $t('passengers.personal.familyNameRequired'),
                            ]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                          <v-text-field
                            v-model="editedItem.cpf"
                            :label="labelDocumentoIdentidade"
                            :rules="[validaDocumentoIdentidade]"
                            @change="cpfChanged"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="4" md="4">
                          <v-text-field
                            v-model="editedItem.telefone"
                            :label="$t('passengers.personal.phone')"
                            type="phone"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                          <v-text-field
                            v-model="editedItem.email"
                            :label="$t('passengers.personal.email')"
                            type="email"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2" md="2">
                          <LazySelect
                            ref="turnoSelect"
                            get-url="getTurnospassageiroslazy"
                            text="descricao_turno"
                            value="id_turno"
                            :label="$t('passengers.personal.shifts')"
                            :request-data="turnoLazyRequestData"
                            @input="onTurnoSelect"
                          />
                        </v-col>
                        <v-col cols="12" sm="2" md="2">
                          <v-text-field
                            v-model="editedItem.matricula"
                            :label="$t('passengers.personal.registrationCode')"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="4" md="2">
                          <v-select
                            v-model="editedItem.sexo"
                            :items="sexo"
                            item-text="text"
                            item-value="value"
                            auto
                            :label="$t('passengers.personal.gender')"
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="4" md="3">
                          <v-select
                            v-model="editedItem.id_empresa"
                            :items="empresas"
                            item-text="razao_social"
                            item-value="id_empresa"
                            clearable
                            auto
                            :label="$t('passengers.personal.selectCompany')"
                            :rules="[validaEmpresa]"
                            :disabled="isEmpresaSelectDisabled"
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="4" md="3">
                          <v-select
                            v-model="editedItem.id_cliente"
                            :items="clientesFiltrados"
                            item-text="nome_cliente"
                            item-value="id_cliente"
                            auto
                            :label="$t('passengers.personal.selectClient')"
                            :rules="[validaCliente]"
                            :disabled="isClienteSelectDisabled"
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                          <v-autocomplete
                            v-model="editedItem.card_no"
                            :label="$t('passengers.personal.cardNumber')"
                            clearable
                            :items="tagsRfidDisponiveis"
                            item-text="identificador_externo"
                            item-value="identificador_interno"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="4" md="3">
                          <LazySelect
                            ref="linhaIdaSelect"
                            get-url="getLinhaslazy"
                            text="cod_linha"
                            value="id_linha"
                            :label="$t('passengers.personal.lineOutbound')"
                            @input="onLinhaIdaSelect"
                          />
                        </v-col>
                        <v-col cols="12" sm="4" md="3">
                          <LazySelect
                            ref="linhaVoltaSelect"
                            get-url="getLinhaslazy"
                            text="cod_linha"
                            value="id_linha"
                            :label="$t('passengers.personal.lineInbound')"
                            @input="onLinhaVoltaSelect"
                          />
                        </v-col>
                      </v-row>

                      <v-row align="center">
                        <v-col cols="12" sm="6" md="4">
                          <v-switch
                            v-model="editedItem.pcd"
                            :label="$t('passengers.personal.pcd')"
                            :true-value="1"
                            :false-value="0"
                            :rules="pcdRules"
                            inset
                            hide-details="auto"
                          />
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="6" md="4">
                          <v-select
                            v-model="idGrupo"
                            :items="grupos"
                            item-text="nome"
                            item-value="id_grupo"
                            auto
                            clearable
                            :label="$t('passengers.personal.selectGroup')"
                            @change="onGrupoChanged"
                            :disabled="isGrupoDisabled"
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-select
                            v-model="idSubgrupo"
                            :items="subgrupos"
                            item-text="nome"
                            item-value="id_grupo"
                            auto
                            clearable
                            :label="$t('passengers.personal.selectSubgroup')"
                            @change="onSubGrupoChanged"
                            :disabled="subgrupos.length === 0"
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="12" md="4">
                          <v-dialog fullscreen v-model="qrcodeDialog">
                            <template v-slot:activator="{ on, attrs }">
                              <v-img
                                :src="
                                  editedItem.qrcode_uri
                                    ? imgSrc +
                                      editedItem.qrcode_uri.substring(
                                        '/static/'.length,
                                      )
                                    : 'mdi-qrcode'
                                "
                                height="10vh"
                                width="5vw"
                                min-height="100px"
                                min-width="120px"
                                lazy-src="mdi-qrcode"
                                style="
                                  padding: 10px;
                                  margin: 5px;
                                  border: 1px solid #4a4a4a;
                                  border-radius: 5px;
                                  box-shadow: #4a4a4a 1px 1px 5px;
                                  cursor: pointer;
                                "
                                v-on="on"
                                v-bind="attrs"
                                :disabled="!editedItem.qrcode_uri"
                              ></v-img>
                            </template>
                            <v-card>
                              <v-toolbar color="primary" dark>
                                <v-toolbar-title>{{
                                  $t("passengers.photos.qrcode")
                                }}</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <div class="body-2 text-white text-center">
                                  {{ $t("passengers.photos.lastQrSend") }}:
                                  <span class="text-white font-weight-medium">{{
                                    editedItem.dt_ultimo_envio_qrcode_extenso ||
                                    editedItem.dt_ultimo_envio_qrcode ||
                                    $t("passengers.photos.lastQrSendNever")
                                  }}</span>
                                </div>
                                <v-btn
                                  dark
                                  color="primary"
                                  depressed
                                  @click="sendQrCode([editedItem])"
                                  v-show="canSendQrCode"
                                  >{{ $t("button.send") }}</v-btn
                                >
                                <v-btn
                                  dark
                                  color="primary"
                                  depressed
                                  @click="downloadQrCode"
                                  >{{ $t("passengers.photos.download") }}</v-btn
                                >
                                <v-btn
                                  dark
                                  color="primary"
                                  depressed
                                  @click="qrcodeDialog = false"
                                  >{{ $t("button.close") }}</v-btn
                                >
                              </v-toolbar>
                              <v-card-text style="height: 80vh">
                                <div
                                  style="
                                    height: 100%;
                                    align-self: center;
                                    align-content: center;
                                  "
                                >
                                  <v-img
                                    :src="
                                      editedItem.qrcode_uri
                                        ? imgSrc +
                                          editedItem.qrcode_uri.substring(
                                            '/static/'.length,
                                          )
                                        : null
                                    "
                                    height="400px"
                                    width="400px"
                                    min-height="70px"
                                    min-width="100px"
                                    lazy-src="mdi-qrcode"
                                    style="
                                      padding: 10px;
                                      margin: 5px;
                                      justify-self: center;
                                    "
                                  ></v-img>
                                  <v-row
                                    justify="center"
                                    style="margin-top: 10px"
                                  >
                                    <!-- <v-icon color="primary" style="margin-right: 10px;">mdi-chevron-left</v-icon> -->
                                    <div>{{ editedItem.card_no }}</div>
                                    <!-- <v-icon color="primary" style="margin-left: 10px;">mdi-chevron-right</v-icon> -->
                                  </v-row>
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-dialog>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="6" md="4">
                          <LazySelect
                            ref="unidadeSelect"
                            get-url="getUnidadeslazy"
                            text="descricao_unidade"
                            value="id_unidade"
                            :label="$t('passengers.personal.selectUnit')"
                            @input="onUnidadeSelect"
                          />
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-autocomplete
                            v-model="editedItem.id_cerca_embarque"
                            :items="cercas"
                            item-text="texto"
                            item-value="id_cerca"
                            auto
                            clearable
                            :label="
                              $t('passengers.personal.selectBoardingPoint')
                            "
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-autocomplete
                            v-model="editedItem.id_cerca_desembarque"
                            :items="cercas"
                            item-text="texto"
                            item-value="id_cerca"
                            auto
                            clearable
                            :label="
                              $t('passengers.personal.selectAlightingPoint')
                            "
                          ></v-autocomplete>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field
                            v-model="editedItem.badge_meli"
                            :label="$t('passengers.personal.badge')"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field
                            v-model="editedItem.cod_cargo"
                            :label="$t('passengers.personal.jobPositionCode')"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field
                            v-model="editedItem.cod_area"
                            :label="$t('passengers.personal.jobAreaCode')"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field
                            v-model="editedItem.lider"
                            :label="$t('passengers.personal.leader')"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>

                  <v-container v-show="tab === 1">
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-file-input
                          :label="$t('passengers.photos.fileInput')"
                          filled
                          prepend-icon="mdi-camera"
                          multiple
                          show-size
                          truncate-length="50"
                          accept="image/png, image/jpeg"
                          v-model="image"
                          @change="onFileChange"
                        ></v-file-input>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-card outlined class="pa-4" color="primary" dark>
                          <div class="d-flex align-center mb-2">
                            <v-icon color="white" class="mr-2" large
                              >mdi-camera-multiple</v-icon
                            >
                            <strong class="text-h6">{{
                              $t("passengers.photos.uploadZipPhotos")
                            }}</strong>
                          </div>
                          <v-divider class="mb-3"></v-divider>
                          <div class="mb-2">
                            <p class="text-body-2 mb-2">
                              {{ $t("passengers.photos.uploadZipPhotosHint") }}
                            </p>
                            <p class="text-caption">
                              {{ $t("passengers.photos.supportedFormats") }}
                            </p>
                          </div>
                          <div class="d-flex align-center">
                            <UploadDialog
                              :token="token"
                              :endpoint="'/api/v1.0/insertpessoasfotoszip'"
                              :user="user.id_usuario"
                              fileType="zip"
                              size="l"
                              icon="mdi-folder-zip"
                              @done="handlePhotosZipDone"
                              @error="handlePhotosZipError"
                            />
                            <span class="ml-3 text-body-1 font-weight-bold">{{
                              $t("passengers.photos.clickToUpload")
                            }}</span>
                          </div>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-item-group>
                      <v-row>
                        <v-col
                          v-for="(item, i) in imageUrl"
                          :key="`NOVA-FOTO-${i}`"
                          cols="12"
                          md="6"
                        >
                          <v-item>
                            <v-img
                              :src="item.imgData"
                              :height="imageUrl ? 300 : 0"
                              max-width="300"
                            >
                              <v-btn
                                icon
                                large
                                @click="removeFoto(item)"
                                style="
                                  background-color: rgba(255, 255, 255, 0.3);
                                  margin: 5px;
                                "
                                :disabled="item.ativo ? true : false"
                              >
                                <v-icon> mdi-close-circle-outline </v-icon>
                              </v-btn>
                            </v-img>
                          </v-item>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                          v-for="(item, i) in fotos"
                          :key="`FOTO-${i}`"
                          cols="12"
                          md="6"
                        >
                          <v-item>
                            <v-img
                              :src="imgSrc + 'uploads/' + item"
                              :height="fotos ? 300 : 0"
                              :class="
                                editedItem.img_uri === 'uploads/' + item
                                  ? 'foto__principal'
                                  : 'foto__comum'
                              "
                              max-width="300"
                              @click="selecionaFotoPrincipal(item)"
                            >
                              <v-btn
                                icon
                                large
                                @click="deleteFoto(item, i)"
                                style="
                                  background-color: rgba(255, 255, 255, 0.3);
                                  margin: 5px;
                                "
                                :disabled="item.ativo ? true : false"
                              >
                                <v-icon> mdi-trash-can-outline </v-icon>
                              </v-btn>
                            </v-img>
                          </v-item>
                        </v-col>
                      </v-row>
                    </v-item-group>
                  </v-container>

                  <v-container v-show="tab === 2">
                    <v-form ref="formEndereco" v-model="formEnderecoValidado">
                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <v-select
                            v-model="editedItem.id_pais"
                            :loading="loadingtext"
                            :label="$t('passengers.address.country')"
                            :items="paises"
                            item-text="nome"
                            item-value="id_pais"
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="editedItem.cep"
                            :label="$t('passengers.address.cep')"
                            :rules="[validaCEP]"
                            @blur="consultaCEP"
                            :loading="loadingtext"
                            :placeholder="
                              $t('passengers.address.cepPlaceholder')
                            "
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="2" md="2">
                          <v-text-field
                            v-model="editedItem.estado"
                            :loading="loadingtext"
                            :label="$t('passengers.address.state')"
                            filled
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="5" md="4">
                          <v-text-field
                            v-model="editedItem.cidade"
                            :loading="loadingtext"
                            :label="$t('passengers.address.city')"
                            filled
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="5" md="3">
                          <v-text-field
                            v-model="editedItem.bairro"
                            :loading="loadingtext"
                            :label="$t('passengers.address.district')"
                            filled
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            v-model="editedItem.endereco"
                            :loading="loadingtext"
                            :label="$t('passengers.address.street')"
                            filled
                            :rules="[
                              (v) =>
                                !!v || $t('passengers.address.streetRequired'),
                            ]"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="3" md="3">
                          <v-text-field
                            v-model="editedItem.numero"
                            :label="$t('passengers.address.number')"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="9" md="9">
                          <v-text-field
                            v-model="editedItem.complemento"
                            :label="$t('passengers.address.complement')"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>

                  <v-container v-show="tab === 3">
                    <v-form ref="formUsuario" v-model="formUsuarioValidado">
                      <v-row>
                        <v-col cols="12" sm="8" md="8">
                          <v-text-field
                            v-model="editedItem.login"
                            :label="$t('passengers.access.username')"
                            :rules="[
                              (v) =>
                                !!v || $t('passengers.access.usernameRequired'),
                            ]"
                            :disabled="disableLogin"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                          <v-select
                            v-model="editedItem.id_perfil_usuario"
                            :label="$t('passengers.access.userProfile')"
                            :items="perfis"
                            item-value="id_perfil_usuario"
                            item-text="descricao_tipo_usuario"
                            :rules="[validaPerfil]"
                            :disabled="isPerfilDisabled"
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="5" md="5">
                          <v-text-field
                            v-model="editedItem.senha"
                            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="show1 ? 'text' : 'password'"
                            :label="$t('passengers.access.password')"
                            :rules="[validaSenha]"
                            @click:append="show1 = !show1"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="5" md="5">
                          <v-text-field
                            v-model="editedItem.repetirsenha"
                            :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="show2 ? 'text' : 'password'"
                            :label="$t('passengers.access.repeatPassword')"
                            :rules="[validaRepeticaoSenha]"
                            @click:append="show2 = !show2"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2" md="2">
                          <v-switch
                            v-model="isAdministrador"
                            class="ma-2"
                            :label="$t('passengers.access.administrator')"
                            color="#4a4a4a"
                            @change="isAdministradorChanged"
                          ></v-switch>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>

                  <div v-show="tab === 4">
                    <v-container>
                      <v-form
                        ref="formSituacoes"
                        v-model="formSituacoesValidado"
                      >
                        <v-row>
                          <v-col cols="12" sm="12" md="2">
                            <v-select
                              v-model="novaSituacao"
                              :label="$t('passengers.situations.situation')"
                              :items="situacoes"
                              item-text="nome"
                              return-object
                            ></v-select>
                          </v-col>
                          <v-col cols="12" sm="12" md="4">
                            <v-datetime-picker
                              :label="$t('passengers.situations.startValidity')"
                              v-model="dtInicioVigenciaSituacao"
                              :time-picker-props="timeProps"
                              :text-field-props="textFieldProps"
                              time-format="HH:mm:ss"
                              date-format="dd/MM/yyyy"
                              :clear-text="$t('datetime.close')"
                            >
                              <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                              </template>
                              <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                              </template>
                            </v-datetime-picker>
                          </v-col>
                          <v-col cols="12" sm="10" md="4">
                            <v-datetime-picker
                              :label="$t('passengers.situations.endValidity')"
                              v-model="dtFimVigenciaSituacao"
                              :time-picker-props="timeProps"
                              :text-field-props="textFieldProps"
                              time-format="HH:mm:ss"
                              date-format="dd/MM/yyyy"
                              :clear-text="$t('datetime.close')"
                            >
                              <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                              </template>
                              <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                              </template>
                            </v-datetime-picker>
                          </v-col>
                          <v-col cols="12" sm="2" md="2">
                            <v-btn
                              color="primary"
                              dark
                              small
                              class="mb-2"
                              fab
                              :disabled="disableInsertSituacoes"
                              @click="saveSituacao"
                            >
                              <v-icon>{{
                                editingSituacao ? "mdi-check" : "mdi-plus"
                              }}</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                    <v-data-table
                      :headers="headersSituacoes"
                      :items="situacoesUsuario"
                      :search="search"
                      :loading="loadingtable"
                      :sort-by="['ativa', 'dt_inicio_vigencia']"
                      :sort-desc="[true, true]"
                      dense
                      class="elevation-7"
                      locale="pt"
                      style="border-radius: 10px"
                    >
                      <template v-slot:top>
                        <v-toolbar
                          flat
                          color="white"
                          style="border-radius: 10px"
                        >
                          <v-toolbar-title style="color: #4a4a4a">{{
                            $t("passengers.situations.title")
                          }}</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-text-field
                            v-model="searchSituacoes"
                            append-icon="mdi-magnify"
                            :label="$t('system.labels.search')"
                            single-line
                            hide-details
                          ></v-text-field>
                          <v-spacer></v-spacer>
                        </v-toolbar>
                      </template>

                      <template v-slot:item.actions="{ item, index }">
                        <v-icon
                          small
                          class="mr-2"
                          color="green"
                          @click="editSituacao(item, index)"
                          :disabled="item.can_edit == 0"
                          >mdi-pencil</v-icon
                        >

                        <v-icon
                          small
                          class="mr-2"
                          color="red"
                          @click="deleteSituacao(item, index)"
                          :disabled="item.can_delete == 0"
                          >mdi-delete</v-icon
                        >
                      </template>
                    </v-data-table>
                  </div>
                  <div v-show="tab === 5">
                    <v-data-table
                      :headers="headersSituacoesValidacao"
                      :items="situacoesValidacaoUsuario"
                      :search="searchSituacoesValidacao"
                      :loading="loadingtable"
                      :sort-by="['ativa', 'dt_inicio_vigencia']"
                      :sort-desc="[true, true]"
                      dense
                      class="elevation-7"
                      locale="pt"
                      style="border-radius: 10px"
                    >
                      <template v-slot:top>
                        <v-toolbar
                          flat
                          color="white"
                          style="border-radius: 10px"
                        >
                          <v-toolbar-title style="color: #4a4a4a">{{
                            $t("validationSituation.history")
                          }}</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-text-field
                            v-model="searchSituacoesValidacao"
                            append-icon="mdi-magnify"
                            :label="$t('system.labels.search')"
                            single-line
                            hide-details
                          ></v-text-field>
                          <v-spacer></v-spacer>
                        </v-toolbar>
                      </template>
                    </v-data-table>
                  </div>
                </v-card-text>
              </v-card>
            </v-dialog>
          </template>
        </CadastroToolbar>
      </template>

      <template v-slot:item.nome_completo="{ item }">
        <v-tooltip v-if="item.id_pendencia_ssff" top max-width="380">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-1"
              :color="corPendenciaSsff(item)"
              v-bind="attrs"
              v-on="on"
              >mdi-alert</v-icon
            >
          </template>
          <div v-for="linha in linhasPendenciaSsff(item)" :key="linha">
            {{ linha }}
          </div>
        </v-tooltip>
        {{ getNomeCompletoFormatado(item.nome_completo) }}
        <v-chip
          v-if="item.deletado == 1"
          x-small
          color="error"
          class="ml-2"
          dark
          >{{ $t("passengers.deleted") }}</v-chip
        >
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          color="green"
          @click="editItem(item)"
          :disabled="!canEdit"
          >mdi-pencil</v-icon
        >

        <v-icon
          small
          class="mr-2"
          color="red"
          @click="deleteItem(item)"
          :disabled="!canDelete"
          >mdi-delete</v-icon
        >

        <v-icon
          small
          class="mr-2"
          color="blue"
          @click="atualizaIntegracaoFaceid([item], true)"
          :disabled="
            item.atualizado_integracao_faceid == 0 ||
            item.id_situacao_ativa != 1
          "
          >mdi-lock-open</v-icon
        >

        <v-icon
          small
          class="mr-2"
          color="red"
          @click="atualizaIntegracaoFaceid([item], false)"
          :disabled="
            item.atualizado_integracao_faceid == 0 ||
            item.id_situacao_ativa != 1
          "
          >mdi-lock</v-icon
        >

        <v-icon
          small
          class="mr-2"
          color="orange"
          @click="showErrosDialog(item)"
          v-if="item.tem_erros_envio == 1"
          >mdi-alert</v-icon
        >
      </template>
    </merus-data-table>
  </v-container>
</template>

<script>
import axios from "axios";
import apiController from "@/utils/apiController";
import translateDbField from "@/utils/translateDbField";
import { ApiBaseUrl, defaultCountry } from "@/constants";
import DateUtils from "../utils/dateutils";
import LoadingComponent from "./LoadingComponent.vue";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import MerusDataTable from "./Tables/MerusDataTable.vue";
import EventBus from "../utils/eventBus";
import registrarChamadaApiExterna from "../utils/registrarChamadaApiExterna";
import curp from "curp";
import ResultDialogZIP from "./Dialogs/ResultDialogZIP.vue";
import UploadDialog from "./Dialogs/UploadDialog.vue";
import ResultDialogCSV from "./Dialogs/ResultDialogCSV.vue";
import QrCodeSendResultDialog from "./Dialogs/QrCodeSendResultDialog.vue";
import serverTableMixin from "@/mixins/serverTableMixin";
import {
  buildRequestParams,
  computePageState,
  initSortFromDefault,
  fetchAllServerPagesForExport,
} from "@/utils/serverTablePagination";
import {
  getScopedClienteIdForCreate,
  shouldLockClienteOnCreate,
} from "@/utils/sessionCliente";
import LazySelect from "./Selects/LazySelect.vue";
import {
  normalizeHistoricoCadastroPessoa,
  persistHistoricoCadastroPassageiros,
} from "@/utils/historicoCadastroPassageiros";
// import { mapGetters } from "vuex";

export default {
  mixins: [serverTableMixin],
  components: {
    LoadingComponent,
    CadastroToolbar,
    MerusDataTable,
    ResultDialogZIP,
    UploadDialog,
    ResultDialogCSV,
    QrCodeSendResultDialog,
    LazySelect,
  },
  data: () => ({
    search: "",
    errosDialog: false,
    loadingErrosEnvio: false,
    loadingtable: true,
    loadingtext: false,
    loadingSave: false,
    loadingSaveFotos: false,
    loadingSaveSituacoes: false,
    loadingDeleteFotos: false,
    loadingAtualizacaoFaceid: false,
    loadingMessageInternal: null,
    fileLoading: false,
    searchSituacoes: "",
    disableInsertSituacoes: false,
    formValidadoSituacoes: true,
    showConfirmButton: true,
    formValidado: true,
    showAlert: false,
    mensagemAlerta: "",
    tipoAlerta: "success",
    dialog: false,
    dialogSituacoes: false,
    menu2: false,
    menu: false,
    operacao: 0,
    isAdministrador: false,
    isIdClienteDisabled: false,
    isPerfilDisabled: false,
    confirmDialog: false,
    mensagemdialog: "",
    disableLogin: false,
    isGrupoDisabled: false,
    show1: false,
    show2: false,
    qrcodeDialog: false,
    paises: [],
    tab: 0,
    pessoas: [],
    selectedPessoas: [],
    historicoCadastroSessaoId: null,
    historicoPessoaAntes: null,
    historicoCadastroOrigemIntegracao: false,
    headers: [],
    totalPessoas: 0,
    numberOfRows: 10,
    itemsPerPageLastOption: 1000,
    lastItemsPerPageBeforeTodos: null,
    pageNumber: 1,
    serverSortBy: [],
    serverSortDesc: [],
    searchFilters: {},
    pendingOpenIdPessoa: null,
    mostrarInativos: false,
    somentePendenciaSsff: false,
    dialogResolverSsff: false,
    observacaoResolverSsff: "",
    resolvendoSsff: false,
    situacoes: [],
    situacoesUsuario: [],
    situacoesValidacaoUsuario: [],
    searchSituacoesValidacao: "",
    empresas: [],
    clientes: [],
    scopedClienteCreateLocked: false,
    perfis: [],
    turnos: [],
    grupos: [],
    subgrupos: [],
    idGrupo: null,
    idSubgrupo: null,
    hikvisionFieldsSnapshot: null,
    editedIndex: -1,
    passageiroIntegracao: {
      matricula: null,
      nome: null,
      sobrenome: null,
      nome_completo: null,
      badge_meli: null,
      cod_cargo: null,
      cod_area: null,
      cpf: null,
      cep: null,
      endereco: null,
      numero: null,
      complemento: null,
      estado: null,
      cidade: null,
      bairro: null,
      id_pais: null,
      sigla_pais: null,
      cod_integracao_erp: null,
      sexo: null,
      telefone: null,
      email: null,
      id_turno: null,
      cod_turno: null,
      cod_integracao_turno: null,
      id_unidade: null,
      descricao_unidade: null,
      cod_unidade: null,
      cod_integracao_unidade: null,
      lider: null,
      id_linha_ida: null,
      id_linha_volta: null,
      id_rota: null,
      cod_rota: null,
      id_grupo: null,
      cod_grupo: null,
      id_cliente: null,
      id_usuario_inclusao: null,
      pcd: 0,
    },
    defaultPassengerIntegracao: {
      matricula: null,
      nome: null,
      sobrenome: null,
      nome_completo: null,
      badge_meli: null,
      cod_cargo: null,
      cod_area: null,
      cpf: null,
      cep: null,
      endereco: null,
      numero: null,
      complemento: null,
      estado: null,
      cidade: null,
      bairro: null,
      id_pais: null,
      sigla_pais: null,
      cod_integracao_erp: null,
      cod_integracao_turno: null,
      sexo: null,
      telefone: null,
      email: null,
      id_turno: null,
      cod_turno: null,
      id_unidade: null,
      descricao_unidade: null,
      cod_unidade: null,
      cod_integracao_unidade: null,
      lider: null,
      id_linha_ida: null,
      id_linha_volta: null,
      id_rota: null,
      cod_rota: null,
      id_grupo: null,
      cod_grupo: null,
      id_cliente: null,
      id_usuario_inclusao: null,
      pcd: 0,
    },
    editedItem: {
      id_pessoa: null,
      id_usuario: null,
      matricula: null,
      login: null,
      nome_usuario: null,
      nome: null,
      sobrenome: null,
      senha: null,
      repetirsenha: null,
      is_administrador: null,
      id_empresa: null,
      id_cliente: null,
      id_perfil_usuario: null,
      badge_meli: null,
      cod_cargo: null,
      cod_area: null,
      id_grupo: null,
      id_subgrupo: null,
      cpf: null,
      cep: null,
      endereco: null,
      numero: null,
      complemento: null,
      estado: null,
      cidade: null,
      bairro: null,
      id_pais: null,
      sigla_pais: null,
      cod_integracao_faceid: null,
      cod_integracao_erp: null,
      cod_integracao_rfid: null,
      cod_integracao_hikvision_grupo: null,
      numero_fotos: null,
      sexo: null,
      card_no: null,
      qrcode_no: null,
      telefone: null,
      email: null,
      id_turno: null,
      cod_turno: null,
      id_unidade: null,
      descricao_unidade: null,
      id_cerca_embarque: null,
      cod_cerca_embarque: null,
      endereco_cerca_embarque: null,
      id_cerca_desembarque: null,
      cod_cerca_desembarque: null,
      endereco_cerca_desembarque: null,
      id_linha_ida: null,
      id_linha_volta: null,
      id_rota: null,
      lider: null,
      id_usuario_inclusao: null,
      dt_ultimo_envio_qrcode: null,
      dt_ultimo_envio_qrcode_extenso: null,
      pcd: 0,
    },
    deletedItem: {
      id_pessoa: null,
      id_usuario: null,
      matricula: null,
      login: null,
      nome_usuario: null,
      nome: null,
      sobrenome: null,
      senha: null,
      repetirsenha: null,
      is_administrador: null,
      id_cliente: null,
      id_perfil_usuario: null,
      badge_meli: null,
      cod_cargo: null,
      cod_area: null,
      id_grupo: null,
      id_subgrupo: null,
      cpf: null,
      cep: null,
      endereco: null,
      numero: null,
      complemento: null,
      estado: null,
      cidade: null,
      bairro: null,
      id_pais: null,
      sigla_pais: null,
      cod_integracao_faceid: null,
      cod_integracao_erp: null,
      cod_integracao_rfid: null,
      cod_integracao_hikvision_grupo: null,
      numero_fotos: null,
      sexo: null,
      card_no: null,
      qrcode_no: null,
      telefone: null,
      email: null,
      id_turno: null,
      cod_turno: null,
      id_unidade: null,
      descricao_unidade: null,
      id_cerca_embarque: null,
      cod_cerca_embarque: null,
      endereco_cerca_embarque: null,
      id_cerca_desembarque: null,
      cod_cerca_desembarque: null,
      endereco_cerca_desembarque: null,
      id_linha_ida: null,
      id_linha_volta: null,
      id_rota: null,
      lider: null,
      id_usuario_inclusao: null,
      dt_ultimo_envio_qrcode: null,
      dt_ultimo_envio_qrcode_extenso: null,
      pcd: 0,
    },
    defaultItem: {
      id_pessoa: null,
      id_usuario: null,
      matricula: null,
      login: null,
      nome_usuario: null,
      nome: null,
      sobrenome: null,
      senha: null,
      repetirsenha: null,
      is_administrador: null,
      id_empresa: null,
      id_cliente: null,
      id_perfil_usuario: null,
      badge_meli: null,
      cod_cargo: null,
      cod_area: null,
      id_grupo: null,
      id_subgrupo: null,
      cpf: null,
      cep: null,
      endereco: null,
      numero: null,
      complemento: null,
      estado: null,
      cidade: null,
      bairro: null,
      id_pais: null,
      sigla_pais: null,
      cod_integracao_faceid: null,
      cod_integracao_erp: null,
      cod_integracao_rfid: null,
      cod_integracao_hikvision_grupo: null,
      numero_fotos: null,
      sexo: null,
      card_no: null,
      qrcode_no: null,
      telefone: null,
      email: null,
      id_turno: null,
      cod_turno: null,
      id_unidade: null,
      descricao_unidade: null,
      id_cerca_embarque: null,
      cod_cerca_embarque: null,
      endereco_cerca_embarque: null,
      id_cerca_desembarque: null,
      cod_cerca_desembarque: null,
      endereco_cerca_desembarque: null,
      id_linha_ida: null,
      id_linha_volta: null,
      id_rota: null,
      lider: null,
      id_usuario_inclusao: null,
      dt_ultimo_envio_qrcode: null,
      dt_ultimo_envio_qrcode_extenso: null,
      pcd: 0,
    },
    editedSituacao: {
      id_situacao_pessoa: null,
      id_situacao: null,
      id_pessoa: null,
      nome_situacao: null,
      prioridade: null,
      dt_inicio_vigencia: null,
      dt_fim_vigencia: null,
      dt_inclusao: null,
      dt_ultima_alteracao: null,
      id_usuario_inclusao: null,
      id_usuario_ultima_alteracao: null,
    },
    defaultSituacao: {
      id_situacao_pessoa: null,
      id_situacao: null,
      id_pessoa: null,
      nome_situacao: null,
      prioridade: null,
      dt_inicio_vigencia: null,
      dt_fim_vigencia: null,
      dt_inclusao: null,
      dt_ultima_alteracao: null,
      id_usuario_inclusao: null,
      id_usuario_ultima_alteracao: null,
    },
    novaSituacao: null,
    user: null,
    token: null,
    authDialog: false,
    sysError: null,
    image: [],
    imageUrl: [],
    uploadDialog: false,
    arquivoCsv: null,
    fimProcesso: false,
    mensagemUpload: null,
    idempresaupload: null,
    fotos: [],
    deletedFoto: null,
    zipFile: null,
    loadingZipUpload: false,
    zipResultDialog: false,
    zipResult: null,
    dtInicioVigenciaSituacao: null,
    dtFimVigenciaSituacao: null,
    textFieldProps: {
      prependInnerIcon: "mdi-calendar",
      rules: [], // (v) => v > this.dtfimbase || "Data início deve ser menor que data fim !"]
    },
    timeProps: {
      useSeconds: true,
    },
    editingSituacao: false,
    editedSituacaoIndex: -1,
    formPessoalValidado: false,
    formEnderecoValidado: false,
    formUsuarioValidado: false,
    formSituacoesValidado: false,
    errosEnvio: [],
    config: null,
    unidades: [],
    cercas: [],
    tags: [],
    arquivoLogBulk: null,
    showResultDeleteDialog: false,
    showResultGoogleSheetsDialog: false,
    dialogGoogleSheetsImport: false,
    googleSheetsUrl: "",
    loadingGoogleSheetsImport: false,
    csvResultGoogleSheets: {
      error: true,
      arqlog: "",
      result: [],
    },
    csvResultDelete: {
      error: true,
      arqlog: "",
      result: [],
    },
    loadingDelete: false,
    recursos: [],
    permissoes: [],
    canInsert: false,
    canEdit: false,
    canDelete: false,
    canIntegrate: false,
    canResolveSsff: false,
    canSendQrCode: false,
    dialogIntegracaoSSFF: false,
    formIntegracaoSSFFValidado: false,
    docToSearch: null,
    loadingIntegracaoSSFF: false,
    dialogResultIntegracaoSSFF: false,
    dialogFindInDatabase: false,
    formFindInDatabaseValidado: false,
    emailToSearch: null,
    loadingFindInDatabase: false,
    loadingSendQrCode: false,
    qrCodeSendResultDialog: false,
    qrCodeSendResults: [],
    qrCodeSendSummary: { total: 0, sucessos: 0, erros: 0 },
  }),
  computed: {
    /** Parametros extras repassados ao getallpessoas na exportacao em background. */
    exportRequestParams() {
      const params = { showInactives: this.mostrarInativos ? "true" : "false" };
      if (this.somentePendenciaSsff) params.filter_pendencia_ssff = "1";
      return params;
    },
    selectedPessoasIds() {
      return (this.selectedPessoas || [])
        .map((p) => p && p.id_pessoa)
        .filter((id) => id != null && id !== '');
    },
    loadingMessage: {
      get() {
        return (
          this.loadingMessageInternal || this.$t("system.messages.loading")
        );
      },
      set(value) {
        this.loadingMessageInternal = value;
      },
    },
    headersCSV() {
      return [
        {
          text: this.$t("passengers.csvHeaders.lineNumber"),
          value: "line_number",
          error: "error_line",
        },
        {
          text: this.$t("passengers.csvHeaders.operation"),
          value: "operacao",
          error: "error_operacao",
        },
        {
          text: this.$t("passengers.csvHeaders.company"),
          value: "cod_empresa",
          error: "error_empresa",
        },
        {
          text: this.$t("passengers.csvHeaders.client"),
          value: "cod_cliente",
          error: "error_cliente",
        },
        {
          text: this.$t("passengers.csvHeaders.unit"),
          value: "cod_unidade",
          error: "error_unidade",
        },
        {
          text: this.$t("passengers.csvHeaders.cpf"),
          value: "cpf",
          error: "error_cpf",
        },
        {
          text: this.$t("passengers.csvHeaders.name"),
          value: "nome",
          error: "error_nome",
        },
        {
          text: this.$t("passengers.csvHeaders.familyName"),
          value: "sobrenome",
          error: "error_sobrenome",
        },
        {
          text: this.$t("passengers.csvHeaders.registrationCode"),
          value: "matricula",
          error: "error_matricula",
        },
        {
          text: this.$t("passengers.csvHeaders.badge"),
          value: "badge_meli",
          error: "error_badge_meli",
        },
        {
          text: this.$t("passengers.csvHeaders.jobPositionCode"),
          value: "cod_cargo",
          error: "error_cod_cargo",
        },
        {
          text: this.$t("passengers.csvHeaders.jobAreaCode"),
          value: "cod_area",
          error: "error_cod_area",
        },
        {
          text: this.$t("passengers.csvHeaders.cep"),
          value: "cep",
          error: "error_cep",
        },
        {
          text: this.$t("passengers.csvHeaders.street"),
          value: "endereco",
          error: "error_endereco",
        },
        {
          text: this.$t("passengers.csvHeaders.number"),
          value: "numero",
          error: "error_numero",
        },
        {
          text: this.$t("passengers.csvHeaders.complement"),
          value: "complemento",
          error: "error_complemento",
        },
        {
          text: this.$t("passengers.csvHeaders.district"),
          value: "bairro",
          error: "error_bairro",
        },
        {
          text: this.$t("passengers.csvHeaders.city"),
          value: "cidade",
          error: "error_cidade",
        },
        {
          text: this.$t("passengers.csvHeaders.state"),
          value: "estado",
          error: "error_estado",
        },
        {
          text: this.$t("passengers.csvHeaders.country"),
          value: "pais",
          error: "error_pais",
        },
        {
          text: this.$t("passengers.csvHeaders.phone"),
          value: "telefone",
          error: "error_telefone",
        },
        {
          text: this.$t("passengers.csvHeaders.email"),
          value: "email",
          error: "error_email",
        },
        {
          text: this.$t("passengers.csvHeaders.gender"),
          value: "sexo",
          error: "error_sexo",
        },
        {
          text: this.$t("passengers.csvHeaders.pcd"),
          value: "pcd",
          error: "error_pcd",
        },
        {
          text: this.$t("passengers.csvHeaders.shift"),
          value: "cod_turno",
          error: "error_turno",
        },
        {
          text: this.$t("passengers.csvHeaders.route"),
          value: "cod_rota",
          error: "error_cod_rota",
        },
        {
          text: this.$t("passengers.csvHeaders.lineOutbound"),
          value: "cod_linha_ida",
          error: "error_cod_linha_ida",
        },
        {
          text: this.$t("passengers.csvHeaders.lineInbound"),
          value: "cod_linha_volta",
          error: "error_cod_linha_volta",
        },
        {
          text: this.$t("passengers.csvHeaders.boarding"),
          value: "cod_embarque",
          error: "error_cod_embarque",
        },
        {
          text: this.$t("passengers.csvHeaders.alighting"),
          value: "cod_desembarque",
          error: "error_cod_embarque",
        },
        {
          text: this.$t("passengers.csvHeaders.cardNo"),
          value: "card_no",
          error: "error_card_no",
        },
        {
          text: this.$t("passengers.csvHeaders.group"),
          value: "nome_grupo",
          error: "error_nome_grupo",
        },
        {
          text: this.$t("passengers.csvHeaders.login"),
          value: "login",
          error: "error_login",
        },
      ];
    },
    defaultSort() {
      return [
        {
          value: "nome_completo",
          options: { text: this.$t("situations.increasing"), value: 1 },
        },
      ];
    },
    headersCSVDelete() {
      return [
        {
          text: this.$t("passengers.csvHeaders.lineNumber"),
          value: "line_number",
          error: "error_line",
        },
        {
          text: this.$t("passengers.csvHeaders.operation"),
          value: "operacao",
          error: "error_operacao",
        },
        {
          text: this.$t("passengers.csvHeaders.unit"),
          value: "cod_unidade",
          error: "error_cod_unidade",
        },
        {
          text: this.$t("passengers.csvHeaders.name"),
          value: "nome",
          error: "error_nome",
        },
        {
          text: this.$t("passengers.csvHeaders.familyName"),
          value: "sobrenome",
          error: "error_sobrenome",
        },
        {
          text: this.$t("passengers.csvHeaders.cpf"),
          value: "cpf",
          error: "error_cpf",
        },
        {
          text: this.$t("passengers.csvHeaders.registrationCode"),
          value: "matricula",
          error: "error_matricula",
        },
        {
          text: this.$t("passengers.csvHeaders.email"),
          value: "email",
          error: "error_email",
        },
      ];
    },
    helpCSV() {
      return [
        {
          label: this.$t("passengers.helpCsv.codeCompany"),
          description: this.$t("passengers.helpCsv.descriptionCompany"),
          example: "25",
          key: "cod_empresa",
        },
        {
          label: this.$t("passengers.helpCsv.codeClient"),
          description: this.$t("passengers.helpCsv.descriptionClient"),
          example: "TST",
          key: "cod_cliente",
        },
        {
          label: this.$t("passengers.helpCsv.codeUnit"),
          description: this.$t("passengers.helpCsv.descriptionUnit"),
          example: "U1",
          key: "cod_unidade",
        },
        {
          label: this.$t("passengers.helpCsv.labelCpf"),
          description: this.$t("passengers.helpCsv.descriptionCpf"),
          example: "12345678900",
          key: "cpf",
        },
        {
          label: this.$t("passengers.helpCsv.labelName"),
          description: this.$t("passengers.helpCsv.descriptionName"),
          example: "Passageiro",
          key: "nome",
        },
        {
          label: this.$t("passengers.helpCsv.labelSurname"),
          description: this.$t("passengers.helpCsv.descriptionSurname"),
          example: "de Teste",
          key: "sobrenome",
        },
        {
          label: this.$t("passengers.helpCsv.labelRegistrationCode"),
          description: this.$t(
            "passengers.helpCsv.descriptionRegistrationCode",
          ),
          example: "1234",
          key: "matricula",
        },
        {
          label: this.$t("passengers.helpCsv.labelBadge"),
          description: this.$t("passengers.helpCsv.descriptionBadge"),
          example: "1234567890",
          key: "badge_meli",
        },
        {
          label: this.$t("passengers.helpCsv.labelJobPositionCode"),
          description: this.$t("passengers.helpCsv.descriptionJobPositionCode"),
          example: "ADM",
          key: "cod_cargo",
        },
        {
          label: this.$t("passengers.helpCsv.labelJobAreaCode"),
          description: this.$t("passengers.helpCsv.descriptionJobAreaCode"),
          example: "TI",
          key: "cod_area",
        },
        {
          label: this.$t("passengers.helpCsv.labelCep"),
          description: this.$t("passengers.helpCsv.descriptionCep"),
          example: "123456000",
          key: "cep",
        },
        {
          label: this.$t("passengers.helpCsv.labelStreet"),
          description: this.$t("passengers.helpCsv.descriptionStreet"),
          example: "Rua Teste",
          key: "endereco",
        },
        {
          label: this.$t("passengers.helpCsv.labelNumber"),
          description: this.$t("passengers.helpCsv.descriptionNumber"),
          example: "1",
          key: "numero",
        },
        {
          label: this.$t("passengers.helpCsv.labelComp"),
          description: this.$t("passengers.helpCsv.descriptionComp"),
          example: "44",
          key: "complemento",
        },
        {
          label: this.$t("passengers.helpCsv.labelDistrict"),
          description: this.$t("passengers.helpCsv.descriptionDistrict"),
          example: "Bairro Teste",
          key: "bairro",
        },
        {
          label: this.$t("passengers.helpCsv.labelCity"),
          description: this.$t("passengers.helpCsv.descriptionCity"),
          example: "Cidade Teste",
          key: "cidade",
        },
        {
          label: this.$t("passengers.helpCsv.labelUf"),
          description: this.$t("passengers.helpCsv.descriptionUf"),
          example: "RJ",
          key: "estado",
        },
        {
          label: this.$t("passengers.helpCsv.labelCountry"),
          description: this.$t("passengers.helpCsv.descriptionCountry"),
          example: "BR",
          key: "pais",
        },
        {
          label: this.$t("passengers.helpCsv.labelPhone"),
          description: this.$t("passengers.helpCsv.descriptionPhone"),
          example: "21912345678",
          key: "telefone",
        },
        {
          label: this.$t("passengers.helpCsv.labelEmail"),
          description: this.$t("passengers.helpCsv.descriptionEmail"),
          example: "teste@email.com",
          key: "email",
        },
        {
          label: this.$t("passengers.helpCsv.labelGender"),
          description: this.$t("passengers.helpCsv.descriptionGender"),
          example: "M",
          key: "sexo",
        },
        {
          label: this.$t("passengers.helpCsv.labelPcd"),
          description: this.$t("passengers.helpCsv.descriptionPcd"),
          example: "0",
          key: "pcd",
        },
        {
          label: this.$t("passengers.helpCsv.labelShift"),
          description: this.$t("passengers.helpCsv.descriptionShift"),
          example: "1TURNO",
          key: "cod_turno",
        },
        {
          label: this.$t("passengers.helpCsv.labelRoute"),
          description: this.$t("passengers.helpCsv.descriptionRoute"),
          example: "ROTA001",
          key: "cod_rota",
        },
        {
          label: this.$t("passengers.helpCsv.labelLineOutbound"),
          description: this.$t("passengers.helpCsv.descriptionLineOutbound"),
          example: "L001",
          key: "cod_linha_ida",
        },
        {
          label: this.$t("passengers.helpCsv.labelLineInbound"),
          description: this.$t("passengers.helpCsv.descriptionLineInbound"),
          example: "L002",
          key: "cod_linha_volta",
        },
        {
          label: this.$t("passengers.helpCsv.codeBoarding"),
          description: this.$t("passengers.helpCsv.codeBoardingDescription"),
          example: "PFN001",
          key: "cod_embarque",
        },
        {
          label: this.$t("passengers.helpCsv.codeAlighting"),
          description: this.$t("passengers.helpCsv.codeAlightingDescription"),
          example: "PFN002",
          key: "cod_desembarque",
        },
        {
          label: this.$t("passengers.helpCsv.labelCardNo"),
          description: this.$t("passengers.helpCsv.descriptionCardNo"),
          example: "12345678901234567890",
          key: "card_no",
        },
        {
          label: this.$t("passengers.helpCsv.labelGroup"),
          description: this.$t("passengers.helpCsv.descriptionGroup"),
          example: "GRUPO001",
          key: "nome_grupo",
        },
        {
          label: this.$t("passengers.helpCsv.labelLogin"),
          description: this.$t("passengers.helpCsv.descriptionLogin"),
          example: "usuario@email.com",
          key: "login",
        },
      ];
    },
    csvExportFormats() {
      return [
        {
          value: "legacy",
          text: this.$t("passengers.helpCsv.exportFormatLegacy"),
          excludeKeys: ["cod_linha_ida", "cod_linha_volta"],
        },
        {
          value: "current",
          text: this.$t("passengers.helpCsv.exportFormatCurrent"),
          excludeKeys: ["cod_rota"],
        },
      ];
    },
    // ...mapGetters('config', {
    //   permitirCadastroPassageiros: 'permitirCadastroPassageiros',
    // }),
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("passengers.register")
        : this.$t("passengers.edit");
    },
    formTitleSituacoes() {
      return this.editingSituacao === false
        ? this.$t("passengers.situations.register")
        : this.$t("passengers.situations.edit");
    },
    headersSituacoesValidacao() {
      // Mesmas colunas do historico funcional, sem a coluna de acoes.
      return this.headersSituacoes
        .filter((h) => h.value !== "actions")
        .map((h) => {
          if (h.value === "id_situacao") return { ...h, value: "id_situacao_validacao" };
          if (h.value === "nome_situacao") {
            return {
              ...h,
              text: this.$t("validationSituation.headers.situation"),
              value: "nome_situacao_validacao",
            };
          }
          return h;
        });
    },
    headersSituacoes() {
      return [
        {
          text: this.$t("passengers.situationsHeaders.idPerson"),
          value: "id_pessoa",
          align: " d-none",
        },
        {
          text: this.$t("passengers.situationsHeaders.idSituation"),
          value: "id_situacao",
          align: " d-none",
        },
        {
          text: this.$t("passengers.situationsHeaders.situation"),
          value: "nome_situacao",
        },
        {
          text: this.$t("passengers.situationsHeaders.start"),
          value: "dt_inicio_vigencia_extenso",
        },
        {
          text: this.$t("passengers.situationsHeaders.end"),
          value: "dt_fim_vigencia_extenso",
        },
        {
          text: this.$t("passengers.situationsHeaders.priority"),
          value: "prioridade",
        },
        {
          text: this.$t("passengers.situationsHeaders.actions"),
          value: "actions",
          sortable: false,
        },
      ];
    },
    tabs() {
      return [
        { text: this.$t("passengers.tabs.personal"), disabled: false },
        { text: this.$t("passengers.tabs.photos"), disabled: false },
        { text: this.$t("passengers.tabs.address"), disabled: false },
        { text: this.$t("passengers.tabs.access"), disabled: false },
        { text: this.$t("passengers.tabs.situations"), disabled: false },
        { text: this.$t("validationSituation.title"), disabled: false },
      ];
    },
    sexo() {
      return [
        { text: this.$t("passengers.personal.genderMale"), value: 1 },
        { text: this.$t("passengers.personal.genderFemale"), value: 2 },
        { text: this.$t("passengers.personal.genderNotInformed"), value: 0 },
      ];
    },
    pcdRules() {
      return [
        (v) => v === 0 || v === 1 || this.$t("passengers.personal.pcdRequired"),
      ];
    },
    messageConfirmButton() {
      return this.$t("button.confirm");
    },
    messageDismissButton() {
      return this.$t("button.dismiss");
    },
    loading() {
      return (
        this.loadingErrosEnvio ||
        this.loadingtable ||
        this.loadingtext ||
        this.loadingSave ||
        this.loadingSaveFotos ||
        this.loadingSaveSituacoes ||
        this.loadingDeleteFotos ||
        this.loadingAtualizacaoFaceid ||
        this.loadingDelete ||
        this.loadingIntegracaoSSFF ||
        this.loadingFindInDatabase ||
        this.loadingSendQrCode
      );
    },
    isProcessFinished() {
      return this.fimProcesso;
    },
    isFileLoading() {
      return this.fileLoading;
    },
    imgSrc() {
      return `${ApiBaseUrl}/`;
    },
    cadastroDisabled() {
      return this.config
        ? this.config.permitir_cadastro_passageiros == 0
        : true;
    },
    labelDocumentoIdentidade() {
      // Se não há país selecionado, retorna CPF por padrão
      if (!this.editedItem.id_pais) {
        return "CPF";
      }

      // Busca o país selecionado
      const paisSelecionado = this.paises.find(
        (p) => p.id_pais === this.editedItem.id_pais,
      );

      // Se o país for México (id_pais = 2 ou sigla = 'MX'), retorna CURP
      if (
        paisSelecionado &&
        (paisSelecionado.id_pais === 2 || paisSelecionado.sigla === "MX")
      ) {
        return "CURP";
      }

      // Para Brasil ou outros países, retorna CPF
      return "CPF";
    },
    tagsRfidDisponiveis() {
      let tagsDisponiveis = this.tags.filter((tag) => tag.id_pessoa === null);

      if (this.editedItem.id_pessoa) {
        let tag = this.tags.find(
          (tag) => tag.id_pessoa === this.editedItem.id_pessoa,
        );
        if (tag) {
          tagsDisponiveis.push(tag);
        }
      }

      return tagsDisponiveis;
    },
    isClienteSelectDisabled() {
      return (
        this.isIdClienteDisabled ||
        !this.editedItem.id_empresa ||
        (this.editedIndex === -1 && this.scopedClienteCreateLocked)
      );
    },
    isEmpresaSelectDisabled() {
      return this.editedIndex === -1 && this.scopedClienteCreateLocked;
    },
    turnoLazyRequestData() {
      const id = this.editedItem && this.editedItem.id_unidade;
      if (id == null || id === '') {
        return {};
      }
      const n = Number(id);
      if (!Number.isFinite(n) || n <= 0) {
        return {};
      }
      return { id_unidades: [n] };
    },
    isPassageiroIntegracaoClienteDisabled() {
      return shouldLockClienteOnCreate();
    },
    clientesFiltrados() {
      if (this.editedItem.id_empresa == null || this.editedItem.id_empresa === "") {
        return [];
      }
      const selectedId = this.editedItem.id_cliente;
      return (this.clientes || []).filter((c) => {
        if (!c || String(c.id_empresa) !== String(this.editedItem.id_empresa)) {
          return false;
        }
        if (selectedId != null && String(c.id_cliente) === String(selectedId)) {
          return true;
        }
        return c.ativo === 1 || c.ativo === true;
      });
    },
  },
  watch: {
    mostrarInativos() {
      this.pageNumber = 1;
      this.serverTableLoad({ page: 1 });
    },
    somentePendenciaSsff() {
      this.pageNumber = 1;
      this.serverTableLoad({ page: 1 });
    },
    dialog(val) {
      if (val) {
        this.$nextTick(() => {
          if (this.editedIndex === -1) {
            this.applyScopedClienteEmpresaOnCreate();
            this.applySingleEmpresaIfOnlyOption();
          }
          this.syncUnidadeSelect();
          this.syncTurnoSelect();
          this.syncLinhaIdaSelect();
          this.syncLinhaVoltaSelect();
        });
        if (this.editedIndex === -1) {
          this.hikvisionFieldsSnapshot = null;
          this.situacoesUsuario.push({
            id_situacao: 1,
            id_pessoa: null,
            nome_situacao: this.$t("contract.active"),
            prioridade: 5,
            dt_inicio_vigencia: DateUtils.getDateSQLFormatted(new Date()),
            dt_inicio_vigencia_extenso: new Date().toLocaleString(),
            dt_fim_vigencia: null,
            id_usuario_inclusao: this.user.id_usuario,
          });
        }
      }
      val || this.close();
    },
    clientes() {
      if (this.dialog && this.editedIndex === -1) {
        this.applyScopedClienteEmpresaOnCreate();
        this.applySingleEmpresaIfOnlyOption();
      }
    },
    empresas() {
      if (this.dialog && this.editedIndex === -1) {
        this.$nextTick(() => {
          this.applyScopedClienteEmpresaOnCreate();
          this.applySingleEmpresaIfOnlyOption();
        });
      }
    },
    "editedItem.id_empresa"() {
      if (this.editedItem.id_cliente == null) {
        return;
      }
      const ok = this.clientesFiltrados.some(
        (c) => String(c.id_cliente) === String(this.editedItem.id_cliente),
      );
      if (!ok) {
        this.editedItem.id_cliente = null;
      }
    },
    "editedItem.id_cliente"(val) {
      if (val == null || val === "") {
        return;
      }
      const cliente = (this.clientes || []).find(
        (c) => String(c.id_cliente) === String(val),
      );
      if (cliente && cliente.id_empresa != null) {
        this.editedItem.id_empresa = cliente.id_empresa;
      }
    },
    "editedItem.id_pais"() {
      // Revalida o campo CPF/CURP quando o país mudar
      if (this.$refs.formPessoal && this.editedItem.cpf) {
        this.$nextTick(() => {
          this.$refs.formPessoal.validate();
        });
      }
      // Revalida o campo CEP/Código Postal quando o país mudar
      if (this.$refs.formEndereco && this.editedItem.cep) {
        this.$nextTick(() => {
          this.$refs.formEndereco.validate();
        });
      }
    },
    "$i18n.locale"() {
      this.initialize();
      if (this.$refs.formPessoal) {
        this.$refs.formPessoal.resetValidation();
      }
      if (this.$refs.formEndereco) {
        this.$refs.formEndereco.resetValidation();
      }
      if (this.$refs.formUsuario) {
        this.$refs.formUsuario.resetValidation();
      }
      if (this.$refs.formSituacoes) {
        this.$refs.formSituacoes.resetValidation();
      }
    },
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.applyRouteQueryFilters();
    this.getConfig();
    this.populaPermissoes();
    this.populaRecursos();
    this.populaTags();
    this.populaClientes();
    this.populaPerfis();
    this.populaGrupos();
    this.populaEmpresas();
    this.populaSituacoes();
    this.populaTurnos();
    this.populaUnidades();
    this.populaPaises();
  },
  mounted() {
    this.$root.$emit("eventshowback", true);
  },
  methods: {
    historicoCadastroAcaoLabel(acao) {
      const path = `routingHistoryTimeline.passengerRegistry.actions.${String(acao || "").toUpperCase()}`;
      const label = this.$t(path);
      return label === path ? String(acao || "") : label;
    },
    async registrarHistoricoCadastroPassageiros(acao, pessoas, options = {}) {
      const lista = (Array.isArray(pessoas) ? pessoas : [])
        .filter(Boolean)
        .map((pessoa) => normalizeHistoricoCadastroPessoa(pessoa));
      if (!lista.length) return;
      const label = this.historicoCadastroAcaoLabel(acao);
      const result = await persistHistoricoCadastroPassageiros({
        idSessao: this.historicoCadastroSessaoId,
        idUsuario: this.user && this.user.id_usuario,
        acao,
        titulo: label,
        pessoas: lista,
        massivo: options.massivo != null ? !!options.massivo : lista.length > 1,
        metadados: options.metadados || null,
      });
      if (result.ok && result.id_sessao) {
        this.historicoCadastroSessaoId = result.id_sessao;
      }
      if (!result.ok && !result.skipped) {
        console.warn("[CRUDPessoas] histórico não registrado", result.reason);
      }
    },
    pessoaHistoricoComResultado(source, result = {}) {
      return normalizeHistoricoCadastroPessoa(source, {
        id_pessoa: result.id_pessoa != null ? Number(result.id_pessoa) : source.id_pessoa,
        resultado: result.action || result.resultado || null,
      });
    },
    populaPermissoes() {
      apiController.request(apiController.endpoints.getPermissoesusuario, {
        params: { id: this.user.id_usuario },
        onSuccess: (response) => {
          this.permissoes = response.data;
        },
      });
    },
    populaRecursos() {
      if (this.user.is_superadmin === 1) {
        apiController.request(apiController.endpoints.getallRecursos, {
          onSuccess: (response) => {
            this.recursos = response.data;
            this.canEdit = true;
            this.canInsert = true;
            this.canDelete = true;
            this.canIntegrate = true;
            this.canResolveSsff = true;
            this.canSendQrCode = true;
            this.initialize();
          },
        });
      } else {
        apiController.request(apiController.endpoints.getRecursosusuario, {
          params: { id: this.user.id_usuario },
          onSuccess: (response) => {
            this.recursos = response.data;
            this.canEdit = this.recursos.some(
              (r) => r.rota === "/api/v1.0/createpessoa",
            );
            this.canInsert = this.recursos.some(
              (r) =>
                r.rota === "/api/v1.0/createpessoa" ||
                r.rota === "/api/v1.0/upsertpessoasbulk",
            );
            this.canDelete = this.recursos.some(
              (r) => r.rota === "/api/v1.0/deletepessoa",
            );
            this.canIntegrate = this.recursos.some(
              (r) =>
                r.rota === "/api/v1.0/ssff/getemployeebydocument" ||
                r.rota === "/api/v1.0/ssff/getemployeebyemail",
            );
            this.canResolveSsff = this.recursos.some(
              (r) => r.rota === "/api/v1.0/resolvependenciassff",
            );
            this.canSendQrCode = this.recursos.some(
              (r) => r.rota === "/api/v1.0/peoplechat/enviaqrcode",
            );
            this.initialize();
          },
        });
      }
    },
    corPendenciaSsff(item) {
      return item.pendencia_ssff_desativada == 1 ? "error" : "warning";
    },
    linhasPendenciaSsff(item) {
      const motivo = item.pendencia_ssff_motivo;
      const chaveMotivo = `passengers.ssffPending.motivos.${motivo}`;
      const linhas = [this.$te(chaveMotivo) ? this.$t(chaveMotivo) : motivo];
      if (item.pendencia_ssff_job_code || item.pendencia_ssff_cargo) {
        const cargo = [item.pendencia_ssff_cargo, item.pendencia_ssff_job_code]
          .filter(Boolean)
          .join(" · ");
        linhas.push(this.$t("passengers.ssffPending.ssffJob", { cargo }));
      }
      if (item.pendencia_ssff_site) {
        linhas.push(
          this.$t("passengers.ssffPending.ssffSite", { site: item.pendencia_ssff_site }),
        );
      }
      if (item.pendencia_ssff_desativada == 1) {
        linhas.push(this.$t("passengers.ssffPending.deactivated"));
      }
      if (item.pendencia_ssff_dt_deteccao_extenso) {
        linhas.push(
          this.$t("passengers.ssffPending.detectedAt", {
            date: item.pendencia_ssff_dt_deteccao_extenso,
          }),
        );
      }
      return linhas;
    },
    abrirResolverPendenciaSsff() {
      this.observacaoResolverSsff = "";
      this.dialogResolverSsff = true;
    },
    resolverPendenciaSsff() {
      const idPessoa = this.editedItem.id_pessoa;
      this.resolvendoSsff = true;
      apiController.request(apiController.endpoints.resolvePendenciassff, {
        data: { id_pessoa: idPessoa, observacao: this.observacaoResolverSsff || null },
        onSuccess: () => {
          this.resolvendoSsff = false;
          this.dialogResolverSsff = false;
          this.editedItem.id_pendencia_ssff = null;
          const item = (this.pessoas || []).find((p) => p.id_pessoa === idPessoa);
          if (item) item.id_pendencia_ssff = null;
          if (this.somentePendenciaSsff) this.serverTableLoad();
        },
        onError: () => {
          this.resolvendoSsff = false;
        },
      });
    },
    serverTableLoad(options) {
      const state = {
        pageNumber: this.pageNumber,
        numberOfRows: this.numberOfRows,
        serverSortBy: this.serverSortBy,
        serverSortDesc: this.serverSortDesc,
        searchFilters: this.searchFilters,
        lastItemsPerPageBeforeTodos: this.lastItemsPerPageBeforeTodos,
        total: this.totalPessoas,
      };
      const { params, page, rowsPerPage, sortByArr, sortDescArr } =
        buildRequestParams(options, state);
      params.showInactives = this.mostrarInativos ? "true" : "false";
      if (this.somentePendenciaSsff) params.filter_pendencia_ssff = "1";
      this.loadingtable = true;
      apiController.request(apiController.endpoints.getallPessoas, {
        data: params,
        onSuccess: (response) => {
          const data = response.data;
          if (
            data &&
            typeof data.total === "number" &&
            Array.isArray(data.items)
          ) {
            this.pessoas = data.items;
            const updates = computePageState(
              data,
              { page, rowsPerPage, sortByArr, sortDescArr },
              state,
              this.itemsPerPageLastOption,
            );
            this.totalPessoas = updates.total;
            this.pageNumber = updates.pageNumber;
            this.numberOfRows = updates.numberOfRows;
            this.lastItemsPerPageBeforeTodos =
              updates.lastItemsPerPageBeforeTodos;
            this.serverSortBy = updates.serverSortBy;
            this.serverSortDesc = updates.serverSortDesc;
          } else {
            this.pessoas = Array.isArray(data) ? data : [];
            this.totalPessoas = this.pessoas.length;
          }
          this.loadingtable = false;
          this.tryOpenPendingPessoa();
        },
        onError: (e) => {
          this.loadingtable = false;
          console.log("ERRO AXIOS");
          console.log(e);
        },
      });
    },
    applyRouteQueryFilters() {
      const q = (this.$route && this.$route.query) || {};
      if (q.matricula) {
        this.searchFilters = { ...this.searchFilters, matricula: String(q.matricula) };
      } else if (q.search) {
        this.searchFilters = { ...this.searchFilters, matricula: String(q.search) };
      }
      if (q.id_pessoa != null && q.id_pessoa !== '') {
        this.pendingOpenIdPessoa = q.id_pessoa;
      }
    },
    tryOpenPendingPessoa() {
      if (this.pendingOpenIdPessoa == null || this.pendingOpenIdPessoa === '') return;
      const id = this.pendingOpenIdPessoa;
      this.pendingOpenIdPessoa = null;
      const item = (this.pessoas || []).find((p) => String(p.id_pessoa) === String(id));
      if (!item) return;
      this.$nextTick(() => this.editItem(item));
    },
    async loadItemsForExport(onProgress) {
      const selected = this.selectedPessoas;
      if (selected && selected.length > 0) {
        if (typeof onProgress === "function") onProgress(100);
        return selected.slice();
      }
      return fetchAllServerPagesForExport({
        fetchPage: async (params) => {
          const response = await apiController.request(
            apiController.endpoints.getallPessoas,
            {
              data: Object.assign({}, params, this.exportRequestParams),
              silent: true,
            },
          );
          return response && response.data;
        },
        state: {
          total: this.totalPessoas,
          serverSortBy: this.serverSortBy,
          serverSortDesc: this.serverSortDesc,
          searchFilters: this.searchFilters,
        },
        onProgress,
      });
    },
    initialize() {
      if (
        this.serverSortBy.length === 0 &&
        this.defaultSort &&
        this.defaultSort.length > 0
      ) {
        const { serverSortBy, serverSortDesc } = initSortFromDefault(
          this.defaultSort,
        );
        this.serverSortBy = serverSortBy;
        this.serverSortDesc = serverSortDesc;
      }
      this.serverTableLoad();
    },
    checkCountry() {
      this.editedItem.id_pais = this.paises.find(
        (p) => p.sigla === defaultCountry,
      )?.id_pais;
    },
    getConfig() {
      apiController.request(apiController.endpoints.getallConfig, {
        onSuccess: (response) => {
          this.config = response.data[0];
        },
      });
    },
    populaPaises() {
      apiController.request(apiController.endpoints.getallPaises, {
        onSuccess: (response) => {
          this.paises = response.data;
          this.paises.forEach((pais) => {
            pais.nome = translateDbField(pais.translation_key, pais.nome);
            return pais;
          });
          this.checkCountry();
        },
      });
    },
    populaTags() {
      apiController.request(apiController.endpoints.getallTagsrfidativos, {
        onSuccess: (response) => {
          this.tags = response.data;
        },
      });
    },
    populaGrupos() {
      apiController.request(apiController.endpoints.getGruposmatriz, {
        onSuccess: (response) => {
          this.grupos = response.data;
        },
      });
    },
    populaUnidades() {
      apiController.request(apiController.endpoints.getallUnidadesativas, {
        onSuccess: (response) => {
          this.unidades = [
            {
              id_unidade: -1,
              descricao_unidade: "Sem Unidade",
              cod_unidade: "SU",
            },
            ...(response.data || []),
          ];
        },
      });
    },
    populaSubgrupos(id) {
      apiController.request(apiController.endpoints.getSubgrupos, {
        params: { id },
        onSuccess: (response) => {
          this.subgrupos = response.data;
        },
      });
    },
    populaClientes() {
      apiController.request(apiController.endpoints.getallClientes, {
        onSuccess: (response) => {
          this.clientes = response.data;
        },
      });
    },
    populaCercas(idunidade) {
      if (!idunidade) {
        this.cercas = [];
        return;
      }
      apiController.request(
        apiController.endpoints.getCercasvalidacaocandidato,
        {
          params: { id: idunidade },
          onSuccess: (response) => {
            const byId = new Map();
            (response.data || []).forEach((c) => {
              if (c == null || c.id_cerca == null || byId.has(c.id_cerca)) {
                return;
              }
              byId.set(c.id_cerca, {
                ...c,
                texto: [c.cod_cerca, c.nome_cerca]
                  .filter(Boolean)
                  .join(" — "),
              });
            });
            this.cercas = Array.from(byId.values());
          },
        },
      );
    },
    populaTurnos() {
      apiController.request(apiController.endpoints.getallTurnospassageiros, {
        onSuccess: (response) => {
          this.turnos = response.data;
        },
      });
    },
    populaPerfis() {
      apiController.request(apiController.endpoints.getallPerfisusuarios, {
        onSuccess: (response) => {
          this.perfis = response.data.map((perfil) => {
            const translated = translateDbField(
              perfil.translation_key,
              perfil.descricao_tipo_usuario,
            );
            return {
              ...perfil,
              descricao_tipo_usuario: translated,
            };
          });
        },
      });
    },
    populaSituacoes() {
      apiController.request(apiController.endpoints.getallSituacoes, {
        onSuccess: (response) => {
          this.situacoes = response.data;
        },
      });
    },
    populaSituacoesValidacaoUsuarios() {
      // Sem id nao ha o que carregar (cadastro novo). O buildUrl do apiController
      // omite silenciosamente segmentos nulos, o que viraria um 404 sem explicacao
      // na rota /:id em vez de simplesmente nao chamar.
      const idPessoa = this.editedItem && this.editedItem.id_pessoa;
      if (idPessoa == null || idPessoa === "") {
        this.situacoesValidacaoUsuario = [];
        return Promise.resolve();
      }
      return apiController.request(apiController.endpoints.getallSituacoesvalidacaopessoaporid, {
        params: { id: idPessoa },
        onSuccess: (response) => {
          this.situacoesValidacaoUsuario = response.data;
        },
      });
    },
    populaSituacoesUsuarios() {
      apiController.request(
        apiController.endpoints.getallSituacoespessoaporid,
        {
          params: { id: this.editedItem.id_pessoa },
          onSuccess: (response) => {
            this.situacoesUsuario = response.data;
          },
        },
      );
    },
    populaEmpresas() {
      apiController.request(apiController.endpoints.getallEmpresas, {
        onSuccess: (response) => {
          this.empresas = response.data;
        },
      });
    },
    validaSenha() {
      if (!this.editedItem.senha || this.editedItem.senha.length === 0) {
        return this.$t("passengers.access.passwordRequired");
      } else {
        if (this.editedItem.senha === this.editedItem.cpf) {
          return true;
        }

        if (
          !/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[$*&@#])[0-9a-zA-Z$*&@#]{8,}$/.test(
            this.editedItem.senha,
          )
        ) {
          return this.$t("passengers.access.passwordInvalid");
        } else {
          return true;
        }
      }
    },
    validaRepeticaoSenha() {
      if (!this.editedItem.senha || this.editedItem.senha.length === 0) {
        return this.$t("passengers.access.passwordRequired");
      } else {
        if (this.editedItem.senha != this.editedItem.repetirsenha) {
          return this.$t("passengers.access.passwordsMustMatch");
        } else {
          return true;
        }
      }
    },
    validaEmpresa() {
      if (this.isAdministrador) {
        return true;
      }
      if (this.editedItem.id_empresa == null || this.editedItem.id_empresa === "") {
        return this.$t("passengers.personal.companyRequired");
      }
      return true;
    },
    validaCliente() {
      // if (this.isAdministrador) {
      //   return true;
      // } else {
      //   if (this.editedItem.id_cliente == null) {
      //     return this.$t('passengers.personal.clientRequired');
      //   } else {
      //     return true;
      //   }
      // }

      return true;
    },
    validaCPF() {
      const cpf = this.editedItem.cpf;
      if (cpf == null) return this.$t("passengers.personal.cpfRequired");
      return this.isCpfDigitsValid(String(cpf).replace(/\D/g, ""))
        ? true
        : this.$t("passengers.personal.cpfInvalid");
    },
    /** CPF brasileiro: exatamente 11 dígitos (apenas números). */
    isCpfDigitsValid(cpf) {
      if (cpf == null || cpf.length !== 11) return false;
      const falsos = [
        "00000000000",
        "11111111111",
        "22222222222",
        "33333333333",
        "44444444444",
        "55555555555",
        "66666666666",
        "77777777777",
        "88888888888",
        "99999999999",
      ];
      if (falsos.indexOf(cpf) !== -1) return false;
      let soma = 0;
      let resto;
      for (let i = 1; i <= 9; i++)
        soma += parseInt(cpf.substring(i - 1, i), 10) * (11 - i);
      resto = (soma * 10) % 11;
      if (resto === 10 || resto === 11) resto = 0;
      if (resto !== parseInt(cpf.substring(9, 10), 10)) return false;
      soma = 0;
      for (let i = 1; i <= 10; i++)
        soma += parseInt(cpf.substring(i - 1, i), 10) * (12 - i);
      resto = (soma * 10) % 11;
      if (resto === 10 || resto === 11) resto = 0;
      if (resto !== parseInt(cpf.substring(10, 11), 10)) return false;
      return true;
    },
    /** Documento no diálogo de integração: CPF (11 dígitos) ou CURP (18 caracteres). */
    isIntegrationSearchDocValid(docRaw) {
      const trimmed = String(docRaw).trim();
      if (!trimmed) return false;
      const digits = trimmed.replace(/\D/g, "");
      if (digits.length === 11) {
        return this.isCpfDigitsValid(digits);
      }
      const curpCandidate = trimmed.toUpperCase().replace(/\s/g, "");
      if (curpCandidate.length === 18) {
        return curp.validar(curpCandidate) === true;
      }
      return false;
    },
    isIntegrationSearchEmailValid(emailRaw) {
      const e = String(emailRaw).trim();
      if (!e) return false;
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);
    },
    validaCURP() {
      const curpString = this.editedItem.cpf;

      if (curpString == null) return this.$t("passengers.personal.cpfRequired");

      if (curpString.length !== 18)
        return this.$t("passengers.personal.cpfInvalid");

      const isValid = curp.validar(curpString);
      if (!isValid) return this.$t("passengers.personal.cpfInvalid");

      return true;
    },
    validaDocumentoIdentidade() {
      // Se não há país selecionado, usa validação de CPF por padrão
      if (!this.editedItem.id_pais) {
        return this.validaCPF();
      }

      // Busca o país selecionado
      const paisSelecionado = this.paises.find(
        (p) => p.id_pais === this.editedItem.id_pais,
      );

      // Se o país for México (id_pais = 2 ou sigla = 'MX'), valida CURP
      if (
        paisSelecionado &&
        (paisSelecionado.id_pais === 2 || paisSelecionado.sigla === "MX")
      ) {
        return this.validaCURP();
      }

      // Para Brasil ou outros países, valida CPF
      return this.validaCPF();
    },
    validaPerfil() {
      // if (this.editedItem.id_perfil_usuario == null) {
      //   return "Perfil de usuário é obrigatório";
      // }
      return true;
    },
    validaCodigoPostalMX() {
      let codigoPostal = this.editedItem.cep;

      if (codigoPostal == null)
        return this.$t("passengers.address.cepRequired");

      // Código postal mexicano tem 5 dígitos
      if (codigoPostal.length !== 5)
        return this.$t("passengers.address.cepInvalid");

      // Deve conter apenas dígitos
      if (!/^\d+$/.test(codigoPostal))
        return this.$t("passengers.address.cepInvalid");

      return true;
    },
    validaCEP() {
      // Se não há país selecionado, usa validação de CEP por padrão
      if (!this.editedItem.id_pais) {
        let cep = this.editedItem.cep;
        if (cep == null) return this.$t("passengers.address.cepRequired");
        if (cep.length !== 8) return this.$t("passengers.address.cepInvalid");
        return true;
      }

      // Busca o país selecionado
      const paisSelecionado = this.paises.find(
        (p) => p.id_pais === this.editedItem.id_pais,
      );

      // Se o país for México (id_pais = 2 ou sigla = 'MX'), valida código postal mexicano
      if (
        paisSelecionado &&
        (paisSelecionado.id_pais === 2 || paisSelecionado.sigla === "MX")
      ) {
        return this.validaCodigoPostalMX();
      }

      // Para Brasil ou outros países, valida CEP (8 dígitos)
      let cep = this.editedItem.cep;
      if (cep == null) return this.$t("passengers.address.cepRequired");
      if (cep.length !== 8) return this.$t("passengers.address.cepInvalid");
      return true;
    },
    consultaCEP() {
      // Verifica se o país é México - não consulta API brasileira para código postal mexicano
      if (this.editedItem.id_pais) {
        const paisSelecionado = this.paises.find(
          (p) => p.id_pais === this.editedItem.id_pais,
        );
        if (
          paisSelecionado &&
          (paisSelecionado.id_pais === 2 || paisSelecionado.sigla === "MX")
        ) {
          // Para México, não há consulta automática de endereço por código postal
          this.loadingtext = false;
          return;
        }
      }

      let cep = String(this.editedItem.cep || "").replace(/\D/g, "");
      if (cep.length !== 8) {
        this.loadingtext = false;
        return;
      }
      this.loadingtext = true;

      registrarChamadaApiExterna("VIACEP", "CEP_LOOKUP", 1, this.token);
      axios
        .get("https://viacep.com.br/ws/" + cep + "/json/")
        .then((response) => {
          console.log(response.data);
          if (response.data.erro) {
            this.loadingtext = false;
            this.editedItem.cep = "";
            this.editedItem.endereco = null;
          } else {
            this.editedItem.endereco = response.data.logradouro;
            this.editedItem.cidade = response.data.localidade;
            this.editedItem.estado = response.data.uf;
            this.editedItem.bairro = response.data.bairro;
            this.loadingtext = false;
          }
        })
        .catch((e) => {
          console.log("ERRO AXIOS");
          console.log(e);
          this.loadingtext = false;
          EventBus.$emit("show-error", { error: e });
        });
    },
    isAdministradorChanged() {
      if (this.isAdministrador) {
        this.editedItem.id_cliente = null;
        this.editedItem.id_empresa = null;
        this.isIdClienteDisabled = true;
      } else {
        this.isIdClienteDisabled = false;
      }
    },
    applyScopedClienteEmpresaOnCreate() {
      this.scopedClienteCreateLocked = false;
      if (this.editedIndex !== -1 || !shouldLockClienteOnCreate()) {
        return;
      }
      const id = getScopedClienteIdForCreate();
      if (id == null) {
        return;
      }
      const c = (this.clientes || []).find(
        (x) => Number(x.id_cliente) === Number(id),
      );
      if (!c || c.id_empresa == null) {
        return;
      }
      this.editedItem.id_cliente = id;
      this.editedItem.id_empresa = c.id_empresa;
      this.scopedClienteCreateLocked = true;
    },
    applySingleEmpresaIfOnlyOption() {
      if (!this.dialog || this.editedIndex !== -1) {
        return;
      }
      if (this.scopedClienteCreateLocked) {
        return;
      }
      if (
        this.editedItem.id_empresa != null &&
        this.editedItem.id_empresa !== ""
      ) {
        return;
      }
      if (!Array.isArray(this.empresas) || this.empresas.length !== 1) {
        return;
      }
      this.editedItem.id_empresa = this.empresas[0].id_empresa;
    },
    applyLinhaIdaVoltaFromSource(target, source) {
      const src = source || {};
      const ida =
        src.id_linha_ida != null
          ? src.id_linha_ida
          : src.id_rota != null
            ? src.id_rota
            : null;
      const volta =
        src.id_linha_volta !== undefined ? src.id_linha_volta : null;
      target.id_linha_ida = ida;
      target.id_linha_volta = volta;
      target.id_rota = ida;
    },
    editItem(item) {
      this.scopedClienteCreateLocked = false;
      this.historicoPessoaAntes = normalizeHistoricoCadastroPessoa(item);
      this.historicoCadastroOrigemIntegracao = false;
      this.editedIndex = this.pessoas.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.applyLinhaIdaVoltaFromSource(this.editedItem, item);
      this.hikvisionFieldsSnapshot = this.getHikvisionRelevantFields(
        this.editedItem,
      );
      this.editedItem.pcd = this.editedItem.pcd == 1 ? 1 : 0;
      this.tabs[3].disabled = true;
      this.editedItem.repetirsenha = this.editedItem.senha;
      this.idGrupo = this.editedItem.id_grupo;
      if (this.idGrupo) {
        this.populaSubgrupos(this.idGrupo);
        this.idSubgrupo = this.editedItem.id_subgrupo;
      }
      this.populaCercas(this.editedItem.id_unidade);
      this.populaSituacoesUsuarios();
      this.populaSituacoesValidacaoUsuarios();
      this.populaImagens();

      if (
        (this.editedItem.id_empresa == null ||
          this.editedItem.id_empresa === "") &&
        this.editedItem.id_cliente != null
      ) {
        const cliente = (this.clientes || []).find(
          (c) =>
            String(c.id_cliente) === String(this.editedItem.id_cliente),
        );
        if (cliente && cliente.id_empresa != null) {
          this.editedItem.id_empresa = cliente.id_empresa;
        }
      }

      if (this.editedItem.id_pais) {
        this.pais = this.editedItem.id_pais;
      } else {
        this.pais = this.paises.find(
          (p) => p.sigla === defaultCountry,
        )?.id_pais;
        this.editedItem.id_pais = this.pais;
      }

      if (this.editedItem.is_administrador == 1) {
        this.isAdministrador = true;
      } else {
        this.isAdministrador = false;
      }
      if (this.editedItem.id_perfil_usuario == 4) {
        this.isPerfilDisabled = true;
      } else {
        this.isPerfilDisabled = false;
      }
      this.dialog = true;
      this.$nextTick(() => {
        this.syncUnidadeSelect();
        this.syncTurnoSelect();
        this.syncLinhaIdaSelect();
        this.syncLinhaVoltaSelect();
      });
    },
    deleteItem(item) {
      this.deletedItem = Object.assign({}, item);
      this.mensagemdialog = this.$t("passengers.confirmations.delete", {
        name: this.deletedItem.nome_completo,
      });
      this.confirmDialog = true;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.deletedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.historicoPessoaAntes = null;
        this.historicoCadastroOrigemIntegracao = false;
        this.scopedClienteCreateLocked = false;
        (this.disableLogin = false),
          (this.show1 = false),
          (this.show2 = false),
          (this.idGrupo = null),
          (this.idSubgrupo = null),
          (this.hikvisionFieldsSnapshot = null),
          (this.situacoesUsuario = []),
          (this.situacoesValidacaoUsuario = []);
        this.turnosSelected = [];
        this.imageUrl = [];
        this.image = [];
        this.fotos = [];
        this.tab = 0;
        this.isGrupoDisabled = false;
        this.tabs[3].disabled = false;
        this.checkCountry();
        if (this.$refs.unidadeSelect && typeof this.$refs.unidadeSelect.resetData === 'function') {
          this.$refs.unidadeSelect.resetData();
        }
        if (this.$refs.turnoSelect && typeof this.$refs.turnoSelect.resetData === 'function') {
          this.$refs.turnoSelect.resetData();
        }
        if (this.$refs.linhaIdaSelect && typeof this.$refs.linhaIdaSelect.resetData === 'function') {
          this.$refs.linhaIdaSelect.resetData();
        }
        if (this.$refs.linhaVoltaSelect && typeof this.$refs.linhaVoltaSelect.resetData === 'function') {
          this.$refs.linhaVoltaSelect.resetData();
        }
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      });
    },
    closeConfirmDialog() {
      this.deletedItem = Object.assign({}, this.defaultItem);
      this.confirmDialog = false;
      this.mensagemdialog = "";
    },
    getHikvisionRelevantFields(item) {
      const grupo =
        item.cod_integracao_hikvision_grupo != null &&
        item.cod_integracao_hikvision_grupo !== ""
          ? String(item.cod_integracao_hikvision_grupo)
          : "14";
      const sexoRaw =
        item.sexo != null && item.sexo !== "" ? Number(item.sexo) : 0;
      const sexo = Number.isNaN(sexoRaw) ? 0 : sexoRaw;
      const card =
        item.card_no != null && item.card_no !== ""
          ? String(item.card_no)
          : null;
      const qrcode =
        item.qrcode_no != null && item.qrcode_no !== ""
          ? String(item.qrcode_no)
          : null;
      return {
        nome: (item.nome || "").trim(),
        sobrenome: (item.sobrenome || "").trim(),
        sexo,
        cod_integracao_hikvision_grupo: grupo,
        card_no: card,
        qrcode_no: qrcode,
      };
    },
    hikvisionRelevantFieldsChanged() {
      if (this.editedIndex === -1) {
        return true;
      }
      if (!this.hikvisionFieldsSnapshot) {
        return true;
      }
      const cur = this.getHikvisionRelevantFields(this.editedItem);
      const snap = this.hikvisionFieldsSnapshot;
      const keys = [
        "nome",
        "sobrenome",
        "sexo",
        "cod_integracao_hikvision_grupo",
        "card_no",
        "qrcode_no",
      ];
      return keys.some((k) => cur[k] !== snap[k]);
    },
    closeDialogSituacoes() {
      this.dialogParadas = false;
      this.$nextTick(() => {
        this.editedSituacao = Object.assign({}, this.defaultSituacao);
        this.editingParada = false;
        this.paradas = [];
      });
    },
    save() {
      this.syncUnidadeFromSelect();
      this.syncTurnoFromSelect();
      this.syncLinhaIdaFromSelect();
      this.syncLinhaVoltaFromSelect();
      this.$refs.formPessoal.validate();
      this.formEnderecoValidado =
        !this.editedItem.cep || this.$refs.formEndereco.validate();
      this.formUsuarioValidado =
        !this.editedItem.login || this.$refs.formUsuario.validate();

      if (!this.formPessoalValidado) {
        EventBus.$emit("show-alert", {
          mensagem: this.$t("passengers.messages.validationError"),
          tipo: "error",
        });
        this.tab = 0;
        return;
      }

      if (!this.formEnderecoValidado) {
        EventBus.$emit("show-alert", {
          mensagem: this.$t("passengers.messages.validationError"),
          tipo: "error",
        });
        this.tab = 2;
        return;
      }

      if (!this.formUsuarioValidado && !this.editedItem.id_pessoa) {
        EventBus.$emit("show-alert", {
          mensagem: this.$t("passengers.messages.validationError"),
          tipo: "error",
        });
        this.tab = 3;
        return;
      }

      if (this.formPessoalValidado && this.formEnderecoValidado) {
        this.loadingMessage = this.$t("passengers.savingPerson");
        this.loadingSaveFotos = true;

        if (this.isAdministrador) {
          this.editedItem.is_administrador = 1;
        } else {
          this.editedItem.is_administrador = 0;
        }

        if (this.idSubgrupo !== null) {
          this.editedItem.id_grupo = this.idSubgrupo;
        } else if (this.idGrupo !== null) {
          this.editedItem.id_grupo = this.idGrupo;
        }

        this.editedItem.cod_integracao_hikvision_grupo =
          this.editedItem.cod_integracao_hikvision_grupo || "14";
        this.editedItem.contratado = 1;
        this.editedItem.pcd = this.editedItem.pcd == 1 ? 1 : 0;

        if (this.editedIndex === -1) {
          if (!this.editedItem.login) {
            let perfilIndex = this.perfis.findIndex(
              (p) => p.descricao_perfil_usuario === "Passageiro",
            );
            if (perfilIndex !== -1) {
              this.editedItem.login = `${
                this.editedItem.nome.toLowerCase().split(" ")[0]
              }.${this.editedItem.sobrenome.toLowerCase().split(" ")[0]}`;
              this.editedItem.senha = this.editedItem.cpf;
              this.editedItem.id_perfil_usuario =
                this.perfis[perfilIndex].id_perfil_usuario;
            }
          }
        } else {
          this.editedItem.login = null;
        }

        this.editedItem.ativo = 1;
        this.editedItem.integra_hikvision =
          this.hikvisionRelevantFieldsChanged();
        this.editedItem.id_usuario_inclusao = this.user.id_usuario;

        if (this.editedItem.id_pais != null) {
          const paisSelecionado = (this.paises || []).find(
            (p) => Number(p.id_pais) === Number(this.editedItem.id_pais),
          );
          if (paisSelecionado && paisSelecionado.sigla) {
            this.editedItem.sigla_pais = paisSelecionado.sigla;
            this.editedItem.pais = paisSelecionado.sigla;
          }
        }

        // Payload explícito ida/volta (null limpa o sentido); evita fallback legado só com id_rota
        this.editedItem.id_linha_ida =
          this.editedItem.id_linha_ida != null
            ? this.editedItem.id_linha_ida
            : null;
        this.editedItem.id_linha_volta =
          this.editedItem.id_linha_volta != null
            ? this.editedItem.id_linha_volta
            : null;
        this.editedItem.id_rota = this.editedItem.id_linha_ida;

        if (
          (this.editedItem.id_empresa == null ||
            this.editedItem.id_empresa === "") &&
          this.editedItem.id_cliente != null
        ) {
          const cliente = (this.clientes || []).find(
            (c) =>
              String(c.id_cliente) === String(this.editedItem.id_cliente),
          );
          if (cliente && cliente.id_empresa != null) {
            this.editedItem.id_empresa = cliente.id_empresa;
          }
        }

        const historicoFoiEdicao = this.editedItem.id_pessoa != null;
        const historicoFoiIntegracao = this.historicoCadastroOrigemIntegracao;
        const historicoPessoa = Object.assign({}, this.editedItem);
        const historicoAntes = this.historicoPessoaAntes
          ? normalizeHistoricoCadastroPessoa(this.historicoPessoaAntes)
          : null;
        this.operacao = 0;
        apiController.request(apiController.endpoints.createPessoa, {
          data: this.editedItem,
          onSuccess: async (response) => {
            this.loadingSaveFotos = false;
            if (!response.data.erro) {
              historicoPessoa.id_pessoa = response.data.idpessoa || historicoPessoa.id_pessoa;
              const acao = historicoFoiIntegracao
                ? "ADICAO_INTEGRACAO"
                : historicoFoiEdicao
                  ? "EDICAO_MANUAL"
                  : "CADASTRO_MANUAL";
              await this.registrarHistoricoCadastroPassageiros(acao, [historicoPessoa], {
                massivo: false,
                metadados: historicoAntes ? { antes: historicoAntes } : null,
              });
              this.historicoCadastroOrigemIntegracao = false;
              this.historicoPessoaAntes = normalizeHistoricoCadastroPessoa(historicoPessoa);
              if (
                !this.editedItem.cod_integracao_faceid &&
                response.data.codIntegracaoFaceid
              ) {
                this.editedItem.cod_integracao_faceid =
                  response.data.codIntegracaoFaceid;
              }
              this.savefotos();
              this.saveSituacoesOnDatabase(response.data.idpessoa);
            } else {
              this.updateTable(response.data.erro);
            }
          },
          onError: () => {
            this.loadingSaveFotos = false;
          },
        });
      }
    },
    async saveSituacoesOnDatabase(idpessoa) {
      if (this.situacoesUsuario.length > 0) {
        this.loadingSaveSituacoes = true;
        try {
          await Promise.all(
            this.situacoesUsuario.map((s) => {
              if (s.id_situacao_pessoa) {
                return apiController.request(
                  apiController.endpoints.updateSituacaopessoa,
                  { data: s, silent: true },
                );
              } else {
                s.id_pessoa = idpessoa;
                return apiController.request(
                  apiController.endpoints.insertSituacaopessoa,
                  { data: s, silent: true },
                );
              }
            }),
          );
          this.loadingSaveSituacoes = false;
          this.updateTable(false);
        } catch (e) {
          this.loadingSaveSituacoes = false;
          console.log("ERRO AXIOS");
          console.log(e);
          EventBus.$emit("show-error", { error: e });
        }
      }
    },
    savefotos() {
      if (this.imageUrl.length > 0 || this.editedItem.img_uri) {
        this.loadingMessage = "Salvando fotos...";
        this.loadingSaveFotos = true;
        let body = {
          files: JSON.stringify(this.imageUrl),
          folder: `fotos/${this.editedItem.cpf}`,
          cpf: this.editedItem.cpf,
          img_uri: this.editedItem.img_uri,
          cod_integracao_faceid: this.editedItem.cod_integracao_faceid,
        };

        apiController.request(apiController.endpoints.uploadImgbulk, {
          data: body,
          onSuccess: (response) => {
            this.loadingSaveFotos = false;
            this.updateTable(response.data.files[0].error);
          },
          onError: () => {
            this.loadingSaveFotos = false;
          },
        });
      } else {
        this.updateTable(false);
      }
    },
    async resolveCadastroMassivoChunkSize() {
      const DEFAULT_CHUNK = 100;
      const MAX_CHUNK = 500;
      try {
        const response = await apiController.request(
          apiController.endpoints.getallParametrossetup,
          { silent: true },
        );
        const row = response && response.data && response.data[0];
        const value = Number(row && row.tamanho_chunk_cadastro_massivo);
        if (Number.isInteger(value) && value > 0) {
          return Math.min(value, MAX_CHUNK);
        }
      } catch (_err) {
        // Fall back to default when setup is unavailable.
      }
      return DEFAULT_CHUNK;
    },
    async saveBulk(pessoas) {
      this.loadingSave = true;
      this.arquivoLogBulk = null;
      const totalPessoas = pessoas.length;
      const errosDetalhados = [];
      const BATCH_SIZE = await this.resolveCadastroMassivoChunkSize();

      const payload = pessoas.map((pessoa) => {
        const item = Object.assign({}, pessoa);
        item.ativo = 1;
        item.cod_integracao_hikvision_grupo =
          item.cod_integracao_hikvision_grupo || "14";
        item.contratado = 1;
        item.id_usuario_inclusao = this.user.id_usuario;
        item.dt_inicio_vigencia = DateUtils.getDateSQLFormatted(new Date());
        return item;
      });

      this.loadingMessage = this.$t("passengers.messages.processingBulk", {
        processadas: 0,
        total: totalPessoas,
      });

      let sucessos = 0;
      let erros = 0;
      let processadas = 0;
      const historicoSucessos = [];

      try {
        for (let i = 0; i < payload.length; i += BATCH_SIZE) {
          const lote = payload.slice(i, i + BATCH_SIZE);
          const response = await apiController.request(
            apiController.endpoints.upsertPessoasbulk,
            {
              data: lote,
              silent: true,
              config: { timeout: 300000 },
            },
          );

          const data = (response && response.data) || {};
          sucessos += data.sucessos || 0;
          erros += data.falhas || 0;
          processadas += lote.length;
          const resultados = data.resultados || [];

          resultados.forEach((row, index) => {
            if (!row.sucesso) {
              errosDetalhados.push({
                pessoa: row.nome || row.cpf || "Desconhecida",
                erro: row.erro || row.sqlMessage || "Erro desconhecido",
                detalhes: JSON.stringify(row),
              });
            } else {
              historicoSucessos.push(this.pessoaHistoricoComResultado(lote[index] || row, row));
            }
          });

          this.loadingMessage = this.$t("passengers.messages.processingBulk", {
            processadas,
            total: totalPessoas,
          });
        }

        this.loadingSave = false;
        this.loadingMessage = null;

        if (erros > 0 && errosDetalhados.length > 0) {
          try {
            const logResponse = await apiController.request(
              apiController.endpoints.generateLogbulk,
              {
                data: {
                  erros: errosDetalhados,
                  totalPessoas: totalPessoas,
                  sucessos: sucessos,
                },
                silent: true,
              },
            );

            if (!logResponse.data.erro && logResponse.data.logfile) {
              this.arquivoLogBulk = logResponse.data.logfile;
              console.warn(
                `Processamento concluído: ${sucessos} sucesso(s), ${erros} erro(s)`,
              );
              console.warn(`Arquivo de log gerado: ${this.arquivoLogBulk}`);

              EventBus.$emit("show-error", {
                error: {
                  message: this.$t(
                    "passengers.messages.bulkProcessingCompletedWithErrors",
                    {
                      sucessos: sucessos,
                      erros: erros,
                      total: totalPessoas,
                    },
                  ),
                },
              });
            }
          } catch (logError) {
            console.error("Erro ao gerar log:", logError);
          }
        }

        if (sucessos > 0) {
          await this.registrarHistoricoCadastroPassageiros(
            "UPLOAD_MASSA",
            historicoSucessos,
            {
              massivo: true,
              metadados: { total: totalPessoas, sucessos, erros },
            },
          );
          this.updateTable(false);
        } else {
          EventBus.$emit("show-error", {
            error: {
              message: this.$t("passengers.messages.allBulkFailed", {
                total: totalPessoas,
              }),
            },
          });
        }
      } catch (e) {
        this.loadingSave = false;
        this.loadingMessage = null;
        console.log("ERRO AXIOS - saveBulk");
        console.log(e);
        EventBus.$emit("show-error", { error: e });
      }
    },
    saveSituacao() {
      this.$refs.formSituacoes.validate();
      if (this.formSituacoesValidado) {
        this.editedSituacao.id_situacao = this.novaSituacao.id_situacao;
        this.editedSituacao.nome_situacao = this.novaSituacao.nome;
        this.editedSituacao.dt_inicio_vigencia = DateUtils.getDateSQLFormatted(
          this.dtInicioVigenciaSituacao,
        );
        this.editedSituacao.dt_inicio_vigencia_extenso =
          this.dtInicioVigenciaSituacao.toLocaleString();
        this.editedSituacao.dt_fim_vigencia = DateUtils.getDateSQLFormatted(
          this.dtFimVigenciaSituacao,
        );
        this.editedSituacao.dt_fim_vigencia_extenso = this.dtFimVigenciaSituacao
          ? this.dtFimVigenciaSituacao.toLocaleString()
          : null;
        this.editedSituacao.prioridade = this.novaSituacao.prioridade;
        this.editedSituacao.id_usuario_inclusao = this.user.id_usuario;
        this.editedSituacao.can_delete = 1;
        this.editedSituacao.can_edit = 1;
        if (this.editingSituacao) {
          this.editedSituacao.dt_ultima_alteracao =
            DateUtils.getDateSQLFormatted(new Date());
          this.editedSituacao.id_usuario_ultima_alteracao =
            this.user.id_usuario;
          this.situacoesUsuario.splice(this.editedSituacaoIndex);
        }
        this.situacoesUsuario.push(this.editedSituacao);
        this.editedSituacao = Object.assign({}, this.defaultSituacao);

        this.$nextTick(() => {
          this.dtInicioVigenciaSituacao = null;
          this.dtFimVigenciaSituacao = null;
          this.novaSituacao = null;
          this.editingSituacao = false;
          this.editedSituacaoIndex = -1;
          this.$refs.formSituacoes.reset();
        });
      }
    },
    editSituacao(item, i) {
      this.novaSituacao = this.situacoes.find(
        (s) => item.id_situacao == s.id_situacao,
      );
      this.dtInicioVigenciaSituacao = new Date(item.dt_inicio_vigencia);
      this.dtFimVigenciaSituacao = item.dt_fim_vigencia
        ? new Date(item.dt_fim_vigencia)
        : null;
      this.editedSituacao = Object.assign({}, item);
      this.editingSituacao = true;
      this.editedSituacaoIndex = i;
    },
    deleteFoto(item, i) {
      this.deletedFoto = item.toString();
      this.mensagemdialog = this.$t("passengers.confirmations.deletePhoto", {
        name: this.editedItem.nome + " " + this.editedItem.sobrenome,
      });
      this.mensagemCor = "#d60000";
      this.showConfirmButton = true;
      this.confirmDialog = true;
      this.deleteIndex = i;
    },
    deleteFromDatabase() {
      if (!this.deletedFoto) {
        apiController.request(apiController.endpoints.deletePessoa, {
          data: this.deletedItem,
          silent: true,
          onSuccess: async (response) => {
            if (!response.data.error && !response.data.erro) {
              await this.registrarHistoricoCadastroPassageiros(
                "BAIXA_MANUAL",
                [this.deletedItem],
                { massivo: false },
              );
            }
            this.updateTable(response.data.error);
            this.confirmDialog = false;
          },
          onError: (err) => {
            console.log("ERRO AXIOS - ACTIVATE");
            console.log(err.message);
            if (err.message == "Request failed with status code 401") {
              this.sysError = err;
              this.authDialog = true;
            }
          },
        });
      } else {
        apiController.request(apiController.endpoints.deleteFoto, {
          data: {
            src: this.deletedFoto,
            numeroDeFotos: this.editedItem.numero_fotos,
            cpf: this.editedItem.cpf,
          },
          silent: true,
          onSuccess: (response) => {
            console.log(response);
            this.fotos.splice(this.deleteIndex);
            this.mensagemdialog = null;
            this.mensagemCor = null;
            this.showConfirmButton = false;
            this.confirmDialog = false;
            this.deletedFoto = null;
            this.deleteIndex = 0;
            this.populaImagens();
          },
          onError: (err) => {
            this.deletedFoto = null;
            console.log("ERRO AXIOS - ACTIVATE");
            console.log(err.message);
            if (err.message == "Request failed with status code 401") {
              this.sysError = err;
              this.authDialog = true;
            }
          },
        });
      }
    },
    populaImagens() {
      apiController.request(apiController.endpoints.getFotos, {
        params: { pasta: this.editedItem.cpf },
        silent: true,
        onSuccess: (response) => {
          if (!response.data.erro) {
            response.data.imagens.forEach((e) => {
              this.fotos.push("fotos/" + this.editedItem.cpf + "/" + e);
            });
          } else {
            console.log(response.data.mensagem);
          }
        },
        onError: (err) => {
          console.log("ERRO AXIOS - ACTIVATE");
          console.log(err.message);
          if (err.message == "Request failed with status code 401") {
            this.sysError = err;
            this.authDialog = true;
          }
        },
      });
    },
    updateTable(status) {
      if (status) {
        if (this.operacao == 0) {
          this.mensagemAlerta = this.$t("passengers.messages.errorInsert");
        } else {
          if (this.operacao == 1) {
            this.mensagemAlerta = this.$t("passengers.messages.errorUpdate");
          } else {
            this.mensagemAlerta = this.$t("passengers.messages.errorDelete");
          }
        }
        this.tipoAlerta = "error";
        this.showAlert = true;
      } else {
        if (this.operacao == 0) {
          this.mensagemAlerta = this.$t("passengers.messages.successInsert");
        } else {
          if (this.operacao == 1) {
            this.mensagemAlerta = this.$t("passengers.messages.successUpdate");
          } else {
            this.mensagemAlerta = this.$t("passengers.messages.successDelete");
          }
        }
        this.tipoAlerta = "success";
        this.showAlert = true;
      }
      this.loadingMessage = null;
      this.close();
      this.closeConfirmDialog();
      this.initialize();
    },
    onFileChange(file) {
      if (!file) {
        this.imageUrl = [];
      }
      file.forEach((e) => this.createImage(e));
    },
    onZipFileChange(file) {
      if (!file) {
        this.zipFile = null;
      }
    },
    uploadZipPhotos() {
      if (!this.zipFile) {
        EventBus.$emit("show-alert", {
          mensagem: this.$t("passengers.photos.noZipFileSelected"),
          tipo: "error",
        });
        return;
      }

      this.loadingZipUpload = true;
      this.loadingMessage = this.$t("passengers.photos.uploadingZip");

      const formData = new FormData();
      formData.append("zipfile", this.zipFile);

      apiController.request(apiController.endpoints.insertPessoasfotoszip, {
        data: formData,
        onSuccess: (response) => {
          this.loadingZipUpload = false;
          this.loadingMessage = null;

          const data = response.data;
          if (data.erro) {
            EventBus.$emit("show-alert", {
              mensagem:
                data.mensagem || this.$t("passengers.photos.zipUploadError"),
              tipo: "error",
            });
          } else {
            this.zipResult = {
              message: data.mensagem,
              processedFiles: data.processedFiles,
              successful: data.successful,
              failed: data.failed,
              messages: data.results?.system || [],
            };
            this.zipResultDialog = true;

            // Refresh photos if editing a person
            if (this.editedItem && this.editedItem.cpf) {
              this.populaImagens();
            }

            // Clear zip file
            this.zipFile = null;
          }
        },
        onError: (error) => {
          this.loadingZipUpload = false;
          this.loadingMessage = null;
          console.error("Error uploading zip:", error);
        },
      });
    },
    createImage(file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        this.imageUrl.push({
          filename: file.name.split(".")[0],
          imgData: e.target.result,
        });
      };
      reader.readAsDataURL(file);
    },
    removeFoto(item) {
      const index = this.imageUrl.indexOf(item);
      this.imageUrl.splice(index, 1);
      this.image = [];
    },
    showUploadDialog() {
      this.arquivoCsv = null;
      this.fimProcesso = false;
      this.mensagemUpload = null;
      this.fileLoading = false;
      this.uploadDialog = true;
    },
    closeUploadDialog() {
      this.idempresaupload = null;
      this.arquivoCsv = null;
      this.uploadDialog = false;
    },
    submitFile() {
      this.$refs.form.validate();
      if (this.formValidado) {
        let formData = new FormData();

        this.mensagemUpload = "Carregando Arquivo...";
        this.fileLoading = true;
        if (this.arquivoCsv) {
          formData.append("arquivocsv", this.arquivoCsv);
          apiController.request(apiController.endpoints.uploadCsv, {
            data: formData,
            headers: {
              "Content-Type": `multipart/form-data; boundary=${formData._boundary}`,
            },
            onSuccess: (response) => {
              console.log(response);
              this.fileLoading = false;
              this.mensagemUpload = null;
            },
          });
        } else {
          console.log("Não há arquivos");
        }
      }
    },
    processaArquivo() {
      this.mensagemUpload = this.$t("system.messages.processingFile");
      apiController.request(apiController.endpoints.processaCsvpessoas, {
        params: { file: this.idempresaupload, idusuario: this.arquivoCsv.name },
        onSuccess: (response) => {
          console.log(response);
          this.mensagemUpload = "File Processed!";
          this.fileLoading = false;
          this.fimProcesso = true;
          this.arquivoLog = response.data.arqlog;
          this.initialize();
        },
      });
    },
    downloadArquivoLog() {
      apiController.request(apiController.endpoints.downloadLog, {
        params: { filename: this.baseName(this.arquivoLog) },
        config: { responseType: "blob" },
        onSuccess: (response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", this.baseName(this.arquivoLog));
          document.body.appendChild(link);
          link.click();
        },
      });
    },
    baseName(str) {
      var base = new String(str).substring(str.lastIndexOf("/") + 1);
      return base;
    },
    downloadLogBulk() {
      if (!this.arquivoLogBulk) {
        EventBus.$emit("show-error", {
          error: {
            message: this.$t("passengers.messages.logFileNotFound"),
          },
        });
        return;
      }

      apiController.request(apiController.endpoints.downloadLog, {
        params: { filename: this.baseName(this.arquivoLogBulk) },
        config: { responseType: "blob" },
        onSuccess: (response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", this.baseName(this.arquivoLogBulk));
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        },
      });
    },
    onGrupoChanged() {
      if (this.idGrupo) {
        this.populaSubgrupos(this.idGrupo);
        let grupo = this.grupos.find((g) => g.id_grupo === this.idGrupo);
        this.editedItem.cod_integracao_hikvision_grupo = grupo
          ? grupo.cod_integracao_hikvision
          : null;
      } else {
        this.subgrupos = [];
        this.editedItem.cod_integracao_hikvision_grupo = null;
      }
    },
    onSubGrupoChanged() {
      if (this.idSubgrupo) {
        this.isGrupoDisabled = true;
        let grupo = this.subgrupos.find((g) => g.id_grupo === this.idSubgrupo);
        this.editedItem.cod_integracao_hikvision_grupo = grupo
          ? grupo.cod_integracao_hikvision
          : null;
      } else {
        this.isGrupoDisabled = false;
        let grupo = this.grupos.find((g) => g.id_grupo === this.idGrupo);
        this.editedItem.cod_integracao_hikvision_grupo = grupo
          ? grupo.cod_integracao_hikvision
          : null;
      }
    },
    handleErroIntegracao(erro) {
      console.log(erro);
      this.updateTable(true);
    },
    handleSucessoIntegracao(mensagem) {
      console.log(mensagem);
      this.updateTable(false);
    },
    handleAtualizaIntegracao(mensagem) {
      console.log(mensagem);
    },
    cpfChanged() {},
    validaRfid() {
      return true;
    },
    showErrosDialog(item) {
      this.errosDialog = true;
      this.loadingErrosEnvio = true;
      apiController.request(
        apiController.endpoints.getErroshikvisionporpessoa,
        {
          params: { id: item.id_pessoa },
          onSuccess: (response) => {
            this.errosEnvio = response.data;
            this.loadingErrosEnvio = false;
          },
          onError: () => {
            this.loadingErrosEnvio = false;
          },
        },
      );
    },
    selecionaFotoPrincipal(uri) {
      this.editedItem.img_uri = "uploads/" + uri;
    },
    async atualizaIntegracaoFaceid(pessoas, autoriza = true) {
      this.loadingAtualizacaoFaceid = true;
      this.loadingMessage = this.$t("passengers.updatingAccessLevels");

      // Filtra pessoas que têm cod_integracao_faceid
      let pessoasComFaceid = pessoas.filter((p) => p.cod_integracao_faceid);
      const totalPessoas = pessoasComFaceid.length;
      let processadas = 0;
      let sucessos = 0;
      let erros = 0;
      let pulados = 0;
      const errosDetalhados = [];
      const puladosDetalhados = [];
      const historicoSucessos = [];
      const batchSize = 3; // Processar 3 pessoas por vez

      // Função para processar um lote de pessoas
      const processarLote = async (lote) => {
        const promessas = lote.map(async (pessoa) => {
          try {
            // Consulta os níveis de acesso da pessoa
            const niveisResponse = await apiController.request(
              apiController.endpoints.getNiveisacessopessoa,
              {
                params: { codpessoa: pessoa.cod_integracao_faceid },
                silent: true,
                config: { timeout: 30000 },
              },
            );

            // Extrai os códigos de integração dos equipamentos
            let idequipamentos = [];
            if (
              niveisResponse.data &&
              Array.isArray(niveisResponse.data) &&
              niveisResponse.data.length > 0
            ) {
              idequipamentos = niveisResponse.data
                .map((item) => item.cod_integracao_nivel_acesso)
                .filter((cod) => cod != null && cod !== "");
            }

            // Sem nível de acesso não há o que autorizar: a cadeia grupo -> rota ->
            // linha guia -> equipamento FaceID está quebrada para esta pessoa. Isso
            // precisa ser reportado, e não contado como sucesso silencioso.
            if (idequipamentos.length === 0) {
              processadas++;
              pulados++;
              puladosDetalhados.push(
                pessoa.nome_completo ||
                  pessoa.cod_integracao_faceid ||
                  "Desconhecida",
              );
              console.log(
                `Pessoa ${pessoa.cod_integracao_faceid} não possui equipamentos associados, pulando...`,
              );
              this.loadingMessage =
                this.$t("passengers.updatingAccessLevels") +
                ` (${processadas}/${totalPessoas})`;
              return { sucesso: true, pessoa, pulado: true };
            }

            // Constrói o payload para esta pessoa
            let idpessoas = [{ id: pessoa.cod_integracao_faceid }];
            let payload = {
              pessoas: idpessoas,
              equipamentos: idequipamentos,
              autoriza: autoriza,
            };

            // Chama o endpoint de atualização
            const response = await apiController.request(
              apiController.endpoints.pessoasAtualizaniveisacessohikvision,
              {
                data: payload,
                silent: true,
                config: { timeout: 120000 },
              },
            );

            processadas++;
            sucessos++;
            historicoSucessos.push(normalizeHistoricoCadastroPessoa(pessoa));
            this.loadingMessage =
              this.$t("passengers.updatingAccessLevels") +
              ` (${processadas}/${totalPessoas})`;
            console.log(
              `Pessoa ${processadas}/${totalPessoas} processada:`,
              response.data,
            );
            return { sucesso: true, pessoa, response };
          } catch (e) {
            processadas++;
            erros++;
            const erroInfo = {
              pessoa:
                pessoa.nome_completo ||
                pessoa.cod_integracao_faceid ||
                "Desconhecida",
              erro:
                e.response?.data?.mensagem || e.message || "Erro desconhecido",
              detalhes: JSON.stringify(e.response?.data || e.message),
            };
            errosDetalhados.push(erroInfo);
            console.log(
              `Erro ao processar pessoa ${processadas}/${totalPessoas}:`,
              erroInfo,
            );
            return { sucesso: false, pessoa, erro: e };
          }
        });
        return Promise.all(promessas);
      };

      try {
        // Processar em lotes
        for (let i = 0; i < pessoasComFaceid.length; i += batchSize) {
          const lote = pessoasComFaceid.slice(i, i + batchSize);
          await processarLote(lote);

          // Delay entre lotes para evitar sobrecarga
          if (i + batchSize < pessoasComFaceid.length) {
            await new Promise((resolve) => setTimeout(resolve, 500));
          }
        }

        // Finalizar processamento
        this.loadingAtualizacaoFaceid = false;
        this.loadingMessage = null;

        // Mostrar resultado
        if (erros > 0) {
          EventBus.$emit("show-error", {
            error: {
              message: this.$t(
                "passengers.messages.bulkProcessingCompletedWithErrors",
                {
                  sucessos: sucessos,
                  erros: erros,
                  total: totalPessoas,
                },
              ),
            },
          });
        }

        if (pulados > 0) {
          EventBus.$emit("show-alert", {
            mensagem: this.$t("passengers.messages.skippedNoAccessLevel", {
              pulados: pulados,
              total: totalPessoas,
              pessoas: puladosDetalhados.slice(0, 10).join(", "),
            }),
            tipo: "warning",
            duracao: 10000,
          });
        }

        // Atualizar tabela apenas se houver sucessos
        if (sucessos > 0) {
          await this.registrarHistoricoCadastroPassageiros(
            autoriza ? "AUTORIZACAO" : "DESAUTORIZACAO",
            historicoSucessos,
            {
              massivo: pessoasComFaceid.length > 1,
              metadados: { total: totalPessoas, sucessos, erros },
            },
          );
          this.updateTable(false);
        } else if (erros > 0) {
          this.updateTable(true);
        }
      } catch (e) {
        this.loadingAtualizacaoFaceid = false;
        this.loadingMessage = null;
        console.log("ERRO AXIOS - atualizaIntegracaoFaceid");
        console.log(e);
        EventBus.$emit("show-error", { error: e });
        this.updateTable(true);
      }
    },
    downloadQrCode() {
      apiController.request(apiController.endpoints.downloadQrcode, {
        data: {
          id_usuario: this.user.id_usuario,
          id_pessoa: this.editedItem.id_pessoa,
          qrcode_no: this.editedItem.qrcode_no,
        },
        config: { responseType: "blob" },
        onSuccess: (response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", this.editedItem.qrcode_no + "-qr.png"); //or any other extension
          document.body.appendChild(link);
          link.click();
        },
      });
    },
    getNomeCompletoFormatado(nome) {
      if (!nome) {
        return null;
      }

      let fNome = "";
      nome.split(" ").forEach((s) => {
        fNome += s.charAt(0).toUpperCase() + s.substring(1) + " ";
      });
      return fNome;
    },
    onUnidadeSelect(val) {
      this.editedItem.id_unidade = val != null && val !== '' ? val : null;
      const ref = this.$refs.unidadeSelect;
      const cached =
        ref && typeof ref.getCachedSelectedItem === 'function'
          ? ref.getCachedSelectedItem(val)
          : null;
      if (cached) {
        if (cached.cod_unidade != null) this.editedItem.cod_unidade = cached.cod_unidade;
        if (cached.descricao_unidade != null) {
          this.editedItem.descricao_unidade = cached.descricao_unidade;
        }
      } else if (this.editedItem.id_unidade == null) {
        this.editedItem.cod_unidade = null;
        this.editedItem.descricao_unidade = null;
      }
      this.populaCercas(this.editedItem.id_unidade);
      this.$nextTick(() => {
        const turnoRef = this.$refs.turnoSelect;
        if (turnoRef && typeof turnoRef.loadLazyItems === 'function') {
          turnoRef.loadLazyItems(turnoRef.lazySearch || '');
        }
      });
    },
    syncUnidadeFromSelect() {
      const ref = this.$refs.unidadeSelect;
      if (!ref) return;
      const selected = ref.selection;
      if (selected !== undefined) {
        this.editedItem.id_unidade =
          selected != null && selected !== '' ? selected : null;
      }
    },
    syncUnidadeSelect() {
      const ref = this.$refs.unidadeSelect;
      if (!ref || typeof ref.setData !== 'function') return;
      const id = this.editedItem && this.editedItem.id_unidade;
      if (id != null && id !== '') {
        ref.cacheSelectedItems([{
          id_unidade: id,
          cod_unidade: this.editedItem.cod_unidade,
          descricao_unidade: this.editedItem.descricao_unidade,
        }], 'id_unidade');
        ref.setData(id);
      } else if (typeof ref.resetData === 'function') {
        ref.resetData();
      }
      if (typeof ref.loadLazyItems === 'function') {
        ref.loadLazyItems('');
      }
    },
    onTurnoSelect(val) {
      this.editedItem.id_turno = val != null && val !== '' ? val : null;
      const ref = this.$refs.turnoSelect;
      const cached =
        ref && typeof ref.getCachedSelectedItem === 'function'
          ? ref.getCachedSelectedItem(val)
          : null;
      if (cached) {
        if (cached.cod_turno != null) this.editedItem.cod_turno = cached.cod_turno;
        if (cached.descricao_turno != null) {
          this.editedItem.descricao_turno = cached.descricao_turno;
        }
      } else if (this.editedItem.id_turno == null) {
        this.editedItem.cod_turno = null;
        this.editedItem.descricao_turno = null;
      }
    },
    syncTurnoFromSelect() {
      const ref = this.$refs.turnoSelect;
      if (!ref) return;
      const selected = ref.selection;
      if (selected !== undefined) {
        this.editedItem.id_turno =
          selected != null && selected !== '' ? selected : null;
      }
    },
    syncTurnoSelect() {
      const ref = this.$refs.turnoSelect;
      if (!ref || typeof ref.setData !== 'function') return;
      const id = this.editedItem && this.editedItem.id_turno;
      if (id != null && id !== '') {
        ref.cacheSelectedItems([{
          id_turno: id,
          cod_turno: this.editedItem.cod_turno,
          descricao_turno: this.editedItem.descricao_turno,
        }], 'id_turno');
        ref.setData(id);
      } else if (typeof ref.resetData === 'function') {
        ref.resetData();
      }
      if (typeof ref.loadLazyItems === 'function') {
        ref.loadLazyItems('');
      }
    },
    onLinhaIdaSelect(val) {
      this.editedItem.id_linha_ida = val != null && val !== '' ? val : null;
      this.editedItem.id_rota = this.editedItem.id_linha_ida;
      const ref = this.$refs.linhaIdaSelect;
      const cached =
        ref && typeof ref.getCachedSelectedItem === 'function'
          ? ref.getCachedSelectedItem(val)
          : null;
      if (cached) {
        if (cached.cod_linha != null) {
          this.editedItem.cod_linha = cached.cod_linha;
          this.editedItem.cod_rota = cached.cod_linha;
          this.editedItem.cod_linha_ida = cached.cod_linha;
        }
        if (cached.nome_linha != null) this.editedItem.nome_linha = cached.nome_linha;
      } else if (this.editedItem.id_linha_ida == null) {
        this.editedItem.cod_linha = null;
        this.editedItem.cod_rota = null;
        this.editedItem.cod_linha_ida = null;
        this.editedItem.nome_linha = null;
      }
    },
    onLinhaVoltaSelect(val) {
      this.editedItem.id_linha_volta = val != null && val !== '' ? val : null;
      const ref = this.$refs.linhaVoltaSelect;
      const cached =
        ref && typeof ref.getCachedSelectedItem === 'function'
          ? ref.getCachedSelectedItem(val)
          : null;
      if (cached) {
        if (cached.cod_linha != null) this.editedItem.cod_linha_volta = cached.cod_linha;
        if (cached.nome_linha != null) this.editedItem.nome_linha_volta = cached.nome_linha;
      } else if (this.editedItem.id_linha_volta == null) {
        this.editedItem.cod_linha_volta = null;
        this.editedItem.nome_linha_volta = null;
      }
    },
    onLinhaIdaIntegracaoSelect(val) {
      this.passageiroIntegracao.id_linha_ida =
        val != null && val !== '' ? val : null;
    },
    onLinhaVoltaIntegracaoSelect(val) {
      this.passageiroIntegracao.id_linha_volta =
        val != null && val !== '' ? val : null;
    },
    /** Limpa os selects lazy de linha do diálogo de integração (o v-model vive no ref, não no items). */
    resetLinhasIntegracaoSelects() {
      ['linhaIdaIntegracaoSelect', 'linhaVoltaIntegracaoSelect'].forEach((nome) => {
        const ref = this.$refs[nome];
        if (ref && typeof ref.resetData === 'function') ref.resetData();
      });
    },
    syncLinhaIdaFromSelect() {
      const ref = this.$refs.linhaIdaSelect;
      if (!ref) return;
      const selected = ref.selection;
      if (selected !== undefined) {
        this.editedItem.id_linha_ida =
          selected != null && selected !== '' ? selected : null;
        this.editedItem.id_rota = this.editedItem.id_linha_ida;
      }
    },
    syncLinhaVoltaFromSelect() {
      const ref = this.$refs.linhaVoltaSelect;
      if (!ref) return;
      const selected = ref.selection;
      if (selected !== undefined) {
        this.editedItem.id_linha_volta =
          selected != null && selected !== '' ? selected : null;
      }
    },
    syncLinhaIdaSelect() {
      const ref = this.$refs.linhaIdaSelect;
      if (!ref || typeof ref.setData !== 'function') return;
      const id = this.editedItem && this.editedItem.id_linha_ida;
      if (id != null && id !== '') {
        const cod =
          this.editedItem.cod_linha_ida != null
            ? this.editedItem.cod_linha_ida
            : this.editedItem.cod_linha != null
              ? this.editedItem.cod_linha
              : this.editedItem.cod_rota;
        ref.cacheSelectedItems([{
          id_linha: id,
          cod_linha: cod,
          nome_linha: this.editedItem.nome_linha,
        }], 'id_linha');
        ref.setData(id);
      } else if (typeof ref.resetData === 'function') {
        ref.resetData();
      }
      if (typeof ref.loadLazyItems === 'function') {
        ref.loadLazyItems('');
      }
    },
    syncLinhaVoltaSelect() {
      const ref = this.$refs.linhaVoltaSelect;
      if (!ref || typeof ref.setData !== 'function') return;
      const id = this.editedItem && this.editedItem.id_linha_volta;
      if (id != null && id !== '') {
        ref.cacheSelectedItems([{
          id_linha: id,
          cod_linha: this.editedItem.cod_linha_volta,
          nome_linha: this.editedItem.nome_linha_volta,
        }], 'id_linha');
        ref.setData(id);
      } else if (typeof ref.resetData === 'function') {
        ref.resetData();
      }
      if (typeof ref.loadLazyItems === 'function') {
        ref.loadLazyItems('');
      }
    },
    handleDone(data) {
      // Handle successful ZIP upload for passenger data (CSV and/or photos)
      this.zipResult = {
        message:
          data.mensagem ||
          data.message ||
          this.$t("passengers.messages.fileProcessedSuccess"),
        processedFiles: data.processedFiles || 0,
        successful: data.successful || data.processedPhotos || 0,
        failed: data.failed || data.failedPhotos || 0,
        processedPhotos: data.processedPhotos || 0,
        failedPhotos: data.failedPhotos || 0,
        messages: data.messages || data.results?.system || [],
      };
      this.zipResultDialog = true;
      // Refresh the table to show updated data (including photo counts)
      this.initialize();
    },
    handleError(error) {
      console.log("handleError", error);
      EventBus.$emit("show-error", { error });
    },
    handlePhotosZipDone(data) {
      console.log("handlePhotosZipDone - Photo ZIP upload result:", data);
      // Handle successful ZIP upload for photos
      this.zipResult = {
        message:
          data.mensagem ||
          data.message ||
          this.$t("passengers.photos.zipProcessingComplete"),
        processedFiles: data.processedFiles || 0,
        successful: data.successful || 0,
        failed: data.failed || 0,
        messages: data.results?.system || data.messages || [],
      };
      this.zipResultDialog = true;

      // Refresh photos if editing a person
      if (this.editedItem && this.editedItem.cpf) {
        this.populaImagens();
      }

      // Refresh the table to show updated photo counts
      this.initialize();
    },
    handlePhotosZipError(error) {
      console.error("handlePhotosZipError - Photo ZIP upload error:", error);
      EventBus.$emit("show-error", { error });
    },
    handleDoneDelete(data) {
      console.log("handleDoneDelete", data);
      this.csvResultDelete = data;
      this.showResultDeleteDialog = true;
    },
    async saveBulkDelete(pessoasValidas) {
      this.showResultDeleteDialog = false;
      // Processar em lotes
      this.loadingDelete = true;
      this.loadingMessage = this.$t("passengers.messages.processingBulk", {
        processadas: 0,
        total: pessoasValidas.length,
      });
      const totalPessoas = pessoasValidas.length;
      let processadas = 0;
      let sucessos = 0;
      let erros = 0;
      const errosDetalhados = [];
      const historicoSucessos = [];
      const batchSize = 3; // Processar 3 pessoas por vez

      // Função para deletar uma pessoa
      const deletarPessoa = async (pessoa) => {
        try {
          const pessoaData = {
            id_pessoa: pessoa.id_pessoa,
            cpf: pessoa.cpf,
          };

          // Adiciona cod_integracao_faceid apenas se existir
          if (pessoa.cod_integracao_faceid) {
            pessoaData.cod_integracao_faceid = pessoa.cod_integracao_faceid;
          }

          const response = await apiController.request(
            apiController.endpoints.deletePessoa,
            {
              data: pessoaData,
              silent: true,
              config: { timeout: 30000 },
            },
          );

          processadas++;
          if (response.data.erro) {
            erros++;
            const erroInfo = {
              pessoa: pessoa.nome || pessoa.cpf || "Desconhecida",
              erro: response.data.mensagem || "Erro desconhecido",
            };
            errosDetalhados.push(erroInfo);
            console.log(
              `Erro ao deletar pessoa ${processadas}/${totalPessoas}:`,
              erroInfo,
            );
            return { sucesso: false, pessoa, erro: response.data };
          } else {
            sucessos++;
            historicoSucessos.push(normalizeHistoricoCadastroPessoa(pessoa));
            this.loadingMessage = this.$t(
              "passengers.messages.processingBulk",
              { processadas: processadas, total: totalPessoas },
            );
            console.log(
              `Pessoa ${processadas}/${totalPessoas} deletada:`,
              response.data,
            );
            return { sucesso: true, pessoa, response };
          }
        } catch (e) {
          processadas++;
          erros++;
          const erroInfo = {
            pessoa: pessoa.nome || pessoa.cpf || "Desconhecida",
            erro:
              e.response?.data?.mensagem || e.message || "Erro desconhecido",
            detalhes: JSON.stringify(e.response?.data || e.message),
          };
          errosDetalhados.push(erroInfo);
          console.log(
            `Erro ao deletar pessoa ${processadas}/${totalPessoas}:`,
            erroInfo,
          );
          return { sucesso: false, pessoa, erro: e };
        }
      };

      // Função para processar um lote de pessoas
      const processarLote = async (lote) => {
        const promessas = lote.map(async (pessoa) => {
          return await deletarPessoa(pessoa);
        });
        return Promise.all(promessas);
      };

      try {
        // Processar em lotes
        for (let i = 0; i < pessoasValidas.length; i += batchSize) {
          const lote = pessoasValidas.slice(i, i + batchSize);
          await processarLote(lote);

          // Delay entre lotes para evitar sobrecarga
          if (i + batchSize < pessoasValidas.length) {
            await new Promise((resolve) => setTimeout(resolve, 500));
          }
        }

        // Finalizar processamento
        this.loadingMessage = null;

        // Mostrar resultado
        if (erros > 0) {
          EventBus.$emit("show-error", {
            error: {
              message: this.$t(
                "passengers.messages.bulkProcessingCompletedWithErrors",
                {
                  sucessos: sucessos,
                  erros: erros,
                  total: totalPessoas,
                },
              ),
            },
          });
        } else if (sucessos > 0) {
          EventBus.$emit("show-alert", {
            mensagem: this.$t("passengers.messages.bulkDeleteCompleted", {
              sucessos: sucessos,
              total: totalPessoas,
            }),
            tipo: "success",
          });
        }

        // Atualizar tabela apenas se houver sucessos
        if (sucessos > 0) {
          await this.registrarHistoricoCadastroPassageiros(
            "BAIXA_MASSA",
            historicoSucessos,
            {
              massivo: true,
              metadados: { total: totalPessoas, sucessos, erros },
            },
          );
          this.updateTable(false);
        } else if (erros > 0) {
          this.updateTable(true);
        }

        // Mostrar diálogo de resultado
        this.showResultDeleteDialog = false;
        this.loadingDelete = false;
      } catch (e) {
        this.loadingMessage = null;
        this.loadingDelete = false;
        console.log("ERRO AXIOS - handleDoneDelete");
        console.log(e);
        EventBus.$emit("show-error", { error: e });
        this.updateTable(true);
        this.showResultDeleteDialog = false;
      }
    },
    handleErrorDelete(error) {
      console.log("handleErrorDelete", error);
      EventBus.$emit("show-error", { error });
    },
    closeResultGoogleSheetsDialog() {
      this.showResultGoogleSheetsDialog = false;
      this.csvResultGoogleSheets = { error: true, arqlog: "", result: [] };
    },
    async submitGoogleSheetsImport() {
      const url = (this.googleSheetsUrl || "").trim();
      if (!url) {
        EventBus.$emit("show-error", {
          error: {
            message: this.$t("passengers.googleSheetsImport.urlRequired"),
          },
        });
        return;
      }
      this.loadingGoogleSheetsImport = true;
      try {
        const postRes = await apiController.request(
          apiController.endpoints.uploadCsvfromgooglesheets,
          {
            data: { url },
            silent: true,
          },
        );
        const filename = postRes.data && postRes.data.filename;
        if (!filename) {
          throw new Error(this.$t("passengers.googleSheetsImport.fetchFailed"));
        }
        const getRes = await apiController.request(
          apiController.endpoints.processaCsvpessoas,
          {
            params: { file: filename, idusuario: this.user.id_usuario },
            silent: true,
          },
        );
        this.csvResultGoogleSheets = Object.assign({}, getRes.data);
        this.dialogGoogleSheetsImport = false;
        this.googleSheetsUrl = "";
        this.showResultGoogleSheetsDialog = true;
      } catch (e) {
        const msg =
          (e.response && e.response.data && e.response.data.mensagem) ||
          e.message ||
          this.$t("passengers.googleSheetsImport.fetchFailed");
        EventBus.$emit("show-error", { error: { message: msg } });
      } finally {
        this.loadingGoogleSheetsImport = false;
      }
    },
    async searchEmployeeByDocument() {
      if (
        !this.$refs.formIntegracaoSSFF ||
        !this.$refs.formIntegracaoSSFF.validate()
      ) {
        return;
      }
      this.loadingMessage = this.$t("passengers.messages.processing");
      this.loadingIntegracaoSSFF = true;
      try {
        const response = await apiController.request(
          apiController.endpoints.getPessoaporcpf,
          {
            data: { doc: this.docToSearch },
            silent: true,
          },
        );
        if (response.data.error || response.data.length === 0) {
          if (this.docToSearch) {
            try {
              const ssffResponse = await apiController.request(
                apiController.endpoints.ssffGetEmployeebydocument,
                {
                  data: { doc: this.docToSearch },
                  silent: true,
                },
              );
              this.openResultIntegracaoSSFF(
                ssffResponse.data.details?.d?.results,
              );
            } catch (error) {
              console.log("error", error);
              EventBus.$emit("show-error", { error: error });
            } finally {
              this.loadingIntegracaoSSFF = false;
            }
          } else if (this.emailToSearch) {
            try {
              const ssffResponse = await apiController.request(
                apiController.endpoints.ssffGetEmployeebyemail,
                {
                  data: { email: this.emailToSearch },
                  silent: true,
                },
              );
              this.openResultIntegracaoSSFF(
                ssffResponse.data.details?.d?.results,
              );
            } catch (error) {
              console.log("error", error);
              EventBus.$emit("show-error", { error: error });
            } finally {
              this.loadingIntegracaoSSFF = false;
            }
          }
        } else {
          EventBus.$emit("show-alert", {
            tipo: "error",
            mensagem: this.$t("passengers.messages.passengerAlreadyExists"),
          });
          this.loadingIntegracaoSSFF = false;
        }
      } catch (error) {
        console.log("error", error);
        EventBus.$emit("show-error", { error: error });
        this.loadingIntegracaoSSFF = false;
      }
    },
    openResultIntegracaoSSFF(data) {
      if (!data) {
        EventBus.$emit("show-alert", {
          tipo: "error",
          mensagem: this.$t("passengers.messages.noDataFound"),
        });
        return;
      }

      if (data.length === 0) {
        EventBus.$emit("show-alert", {
          tipo: "error",
          mensagem: this.$t("passengers.messages.noDataFound"),
        });
        return;
      }

      if (data.length > 1) {
        EventBus.$emit("show-alert", {
          tipo: "error",
          mensagem: this.$t("passengers.messages.multipleDataFound"),
        });
        return;
      }

      this.buildPassengerData(data[0]);
      this.dialogResultIntegracaoSSFF = true;
      return;
    },
    buildPassengerData(data) {
      const userData = data.userNav;
      const addressData = data.personNav?.homeAddressNavDEFLT?.results?.[0];
      const jobData = data.jobInfoNav?.results?.[0];
      const documentData = data.personNav?.nationalIdNav?.results?.find(
        (item) => item.cardType === "PR" || item.cardType === "0001",
      );
      const siteData = jobData?.customString34Nav;

      const unidade = this.unidades.find(
        (unidade) => unidade.cod_integracao_erp === siteData?.externalCode,
      );
      const turno = this.turnos.find(
        (turno) =>
          turno.cod_integracao_erp === jobData?.workscheduleCode &&
          turno.id_unidade === unidade?.id_unidade,
      );

      this.passageiroIntegracao.nome = userData?.firstName;
      this.passageiroIntegracao.sobrenome = userData?.lastName;
      this.passageiroIntegracao.nome_completo = `${this.passageiroIntegracao.nome} ${this.passageiroIntegracao.sobrenome}`;
      this.passageiroIntegracao.cpf = documentData?.nationalId;
      this.passageiroIntegracao.email = userData?.email;
      this.passageiroIntegracao.telefone = userData?.cellPhone;
      this.passageiroIntegracao.matricula = data?.customLong1;
      this.passageiroIntegracao.cod_cargo = jobData?.jobCodeNav?.name;
      this.passageiroIntegracao.cep = addressData?.zipCode;
      this.passageiroIntegracao.endereco = addressData?.address1;
      this.passageiroIntegracao.numero = addressData?.address2;
      this.passageiroIntegracao.complemento = addressData?.address3;
      this.passageiroIntegracao.cidade = addressData?.city;
      this.passageiroIntegracao.estado = addressData?.stateNav?.localeLabel;
      this.passageiroIntegracao.id_pais =
        addressData?.country === "MEX"
          ? 2
          : addressData?.country === "BRA"
          ? 1
          : null;
      this.passageiroIntegracao.sigla_pais =
        addressData?.country === "MEX"
          ? "MX"
          : addressData?.country === "BRA"
          ? "BR"
          : null;
      this.passageiroIntegracao.cod_integracao_erp = data?.personIdExternal;
      this.passageiroIntegracao.descricao_unidade = siteData?.externalName;
      this.passageiroIntegracao.cod_integracao_unidade = siteData?.externalCode;
      this.passageiroIntegracao.id_unidade = unidade?.id_unidade;
      this.passageiroIntegracao.cod_unidade = unidade?.cod_unidade;
      this.passageiroIntegracao.id_turno = turno?.id_turno;
      this.passageiroIntegracao.cod_turno = turno?.cod_turno;
      this.passageiroIntegracao.cod_integracao_turno =
        jobData?.workscheduleCode;
      const scopedCliente = getScopedClienteIdForCreate();
      if (scopedCliente != null) {
        this.passageiroIntegracao.id_cliente = scopedCliente;
      }
    },
    savePassengerIntegration() {
      const p = this.passageiroIntegracao;

      let nome = (p.nome && String(p.nome).trim()) || "";
      let sobrenome = (p.sobrenome && String(p.sobrenome).trim()) || "";
      if ((!nome || !sobrenome) && p.nome_completo) {
        const parts = String(p.nome_completo)
          .trim()
          .split(/\s+/)
          .filter(Boolean);
        if (!nome && parts.length) nome = parts[0];
        if (!sobrenome && parts.length > 1)
          sobrenome = parts.slice(1).join(" ");
      }

      let idPais =
        p.id_pais != null
          ? p.id_pais
          : this.paises.find((x) => x.sigla === defaultCountry)?.id_pais;
      if (idPais == null) {
        idPais = this.paises[0]?.id_pais;
      }

      const paisSel = this.paises.find((x) => x.id_pais === idPais);

      const doc =
        p.cpf != null && String(p.cpf).trim() !== ""
          ? String(p.cpf).replace(/\s/g, "")
          : null;

      const cep = p.cep != null ? String(p.cep).trim() : null;

      let sexoVal = null;
      if (p.sexo != null && p.sexo !== "") {
        const n = Number(p.sexo);
        sexoVal = Number.isNaN(n) ? null : n;
      }

      this.editedItem = Object.assign({}, this.defaultItem, {
        nome,
        sobrenome,
        cpf: doc,
        telefone:
          p.telefone != null && String(p.telefone).trim() !== ""
            ? String(p.telefone).trim()
            : null,
        email:
          p.email != null && String(p.email).trim() !== ""
            ? String(p.email).trim()
            : null,
        matricula:
          p.matricula != null && String(p.matricula).trim() !== ""
            ? String(p.matricula).trim()
            : null,
        cod_cargo: p.cod_cargo != null ? p.cod_cargo : null,
        cod_area: p.cod_area != null ? p.cod_area : null,
        cep: cep?.replaceAll("-", "") || null,
        endereco: p.endereco != null ? p.endereco : null,
        numero: p.numero != null ? p.numero : null,
        complemento: p.complemento != null ? p.complemento : null,
        estado: p.estado != null ? p.estado : null,
        cidade: p.cidade != null ? p.cidade : null,
        bairro: p.bairro != null ? p.bairro : null,
        id_pais: idPais,
        sigla_pais:
          (p.sigla_pais && String(p.sigla_pais).trim()) ||
          paisSel?.sigla ||
          null,
        cod_integracao_erp:
          p.cod_integracao_erp != null ? p.cod_integracao_erp : null,
        id_turno: p.id_turno != null ? p.id_turno : null,
        cod_turno: p.cod_turno != null ? p.cod_turno : null,
        id_unidade: p.id_unidade != null ? p.id_unidade : null,
        descricao_unidade:
          p.descricao_unidade != null ? p.descricao_unidade : null,
        lider: p.lider != null ? p.lider : null,
        badge_meli: p.badge_meli != null ? p.badge_meli : null,
        pcd: p.pcd == 1 ? 1 : 0,
        sexo: sexoVal,
        id_cliente: p.id_cliente != null ? p.id_cliente : null,
        id_linha_ida:
          p.id_linha_ida != null
            ? p.id_linha_ida
            : p.id_rota != null
              ? p.id_rota
              : null,
        id_linha_volta: p.id_linha_volta != null ? p.id_linha_volta : null,
        id_grupo: p.id_grupo != null ? p.id_grupo : null,
      });

      this.applyLinhaIdaVoltaFromSource(this.editedItem, this.editedItem);

      const scopedCliente = getScopedClienteIdForCreate();
      if (scopedCliente != null) {
        this.editedItem.id_cliente = scopedCliente;
        const cliente = (this.clientes || []).find(
          (c) => Number(c.id_cliente) === Number(scopedCliente),
        );
        if (cliente && cliente.id_empresa != null) {
          this.editedItem.id_empresa = cliente.id_empresa;
          this.scopedClienteCreateLocked = true;
        }
      } else {
        this.scopedClienteCreateLocked = false;
        if (
          (this.editedItem.id_empresa == null ||
            this.editedItem.id_empresa === "") &&
          this.editedItem.id_cliente != null
        ) {
          const cliente = (this.clientes || []).find(
            (c) =>
              String(c.id_cliente) === String(this.editedItem.id_cliente),
          );
          if (cliente && cliente.id_empresa != null) {
            this.editedItem.id_empresa = cliente.id_empresa;
          }
        }
      }

      this.editedIndex = -1;
      this.historicoPessoaAntes = null;
      this.historicoCadastroOrigemIntegracao = true;
      this.hikvisionFieldsSnapshot = null;
      this.imageUrl = [];
      this.image = [];
      this.fotos = [];
      this.situacoesUsuario = [];
      this.situacoesValidacaoUsuario = [];
      this.idGrupo = this.editedItem.id_grupo;
      this.idSubgrupo = this.editedItem.id_subgrupo;
      this.populaSubgrupos(this.idGrupo);
      this.populaCercas(this.editedItem.id_unidade);
      this.tabs[3].disabled = false;
      this.isAdministrador = false;
      this.isPerfilDisabled = false;

      if (this.editedItem.id_pais) {
        this.pais = this.editedItem.id_pais;
      } else {
        this.pais = this.paises.find(
          (x) => x.sigla === defaultCountry,
        )?.id_pais;
        this.editedItem.id_pais = this.pais;
      }

      this.closeDialogResultIntegracaoSSFF();
      this.dialog = true;
      this.$nextTick(() => {
        if (this.editedIndex === -1 && this.situacoesUsuario.length === 0) {
          this.situacoesUsuario.push({
            id_situacao: 1,
            id_pessoa: null,
            nome_situacao: this.$t("contract.active"),
            prioridade: 5,
            dt_inicio_vigencia: DateUtils.getDateSQLFormatted(new Date()),
            dt_inicio_vigencia_extenso: new Date().toLocaleString(),
            dt_fim_vigencia: null,
            id_usuario_inclusao: this.user.id_usuario,
          });
        }
        if (this.$refs.formPessoal) {
          this.$refs.formPessoal.resetValidation();
        }
        if (this.$refs.formEndereco) {
          this.$refs.formEndereco.resetValidation();
        }
        if (this.$refs.formUsuario) {
          this.$refs.formUsuario.resetValidation();
        }
      });
    },
    closeDialogResultIntegracaoSSFF() {
      this.dialogResultIntegracaoSSFF = false;
      this.passageiroIntegracao = Object.assign(
        {},
        this.defaultPassengerIntegracao,
      );
      this.resetLinhasIntegracaoSelects();
      this.closeDialogIntegracaoSSFF();
    },
    closeDialogIntegracaoSSFF() {
      this.dialogIntegracaoSSFF = false;
      this.docToSearch = null;
      this.emailToSearch = null;
      this.formIntegracaoSSFFValidado = false;
      if (this.$refs.formIntegracaoSSFF) {
        this.$refs.formIntegracaoSSFF.resetValidation();
      }
    },
    /** Revalida os dois campos: o Vuetify 2 não reexecuta regras do campo irmão em validação cruzada. */
    onIntegracaoSSFFFieldChange() {
      this.$nextTick(() => {
        this.$refs.formIntegracaoSSFF?.validate();
      });
    },
    addByIntegrationDocRules(v) {
      const doc = v != null ? String(v).trim() : "";
      const email =
        this.emailToSearch != null ? String(this.emailToSearch).trim() : "";
      const docOk = doc.length > 0 && this.isIntegrationSearchDocValid(doc);
      const emailOk =
        email.length > 0 && this.isIntegrationSearchEmailValid(email);
      if (docOk || emailOk) return true;
      if (!doc.length && !email.length) {
        return this.$t("passengers.messages.cpfOrEmailRequired");
      }
      if (doc.length > 0 && !docOk) {
        return this.$t("passengers.personal.cpfInvalid");
      }
      return true;
    },
    addByIntegrationEmailRules(v) {
      const email = v != null ? String(v).trim() : "";
      const doc =
        this.docToSearch != null ? String(this.docToSearch).trim() : "";
      const docOk = doc.length > 0 && this.isIntegrationSearchDocValid(doc);
      const emailOk =
        email.length > 0 && this.isIntegrationSearchEmailValid(email);
      if (docOk || emailOk) return true;
      if (!doc.length && !email.length) {
        return this.$t("passengers.messages.cpfOrEmailRequired");
      }
      if (email.length > 0 && !emailOk) {
        return this.$t("passengers.messages.emailInvalid");
      }
      return true;
    },
    closeDialogFindInDatabase() {
      this.dialogFindInDatabase = false;
      this.docToSearch = null;
      this.emailToSearch = null;
      this.formFindInDatabaseValidado = false;
      if (this.$refs.formFindInDatabase) {
        this.$refs.formFindInDatabase.resetValidation();
      }
    },
    async searchInDatabase() {
      if (
        !this.$refs.formFindInDatabase ||
        !this.$refs.formFindInDatabase.validate()
      ) {
        return;
      }
      this.loadingMessage = this.$t("passengers.messages.processing");
      this.loadingFindInDatabase = true;

      if (this.docToSearch || this.emailToSearch) {
        try {
          const response = await apiController.request(
            apiController.endpoints.getPessoaporchavesunicas,
            {
              data: { doc: this.docToSearch || this.emailToSearch },
              silent: true,
            },
          );
          if (response.data?.length > 0) {
            this.editItem(response.data[0]);
            this.closeDialogFindInDatabase();
          } else {
            EventBus.$emit("show-alert", {
              tipo: "error",
              mensagem: this.$t("passengers.messages.noDataFound"),
            });
          }
        } catch (error) {
          console.log("error", error);
          EventBus.$emit("show-error", { error: error });
        } finally {
          this.loadingFindInDatabase = false;
        }
      }
    },
    restaurarPessoa() {
      this.editedItem.deletado = 0;
    },
    normalizePessoasSelecionadas(pessoas) {
      const raw = Array.isArray(pessoas)
        ? pessoas.filter((p) => p != null)
        : pessoas != null
        ? [pessoas]
        : [];
      const seen = new Set();
      return raw.filter((pessoa) => {
        const id = pessoa.id_pessoa;
        if (id == null || seen.has(id)) {
          return false;
        }
        seen.add(id);
        return true;
      });
    },
    clearSelectedPessoas() {
      this.selectedPessoas = [];
      const tabela = this.$refs.tabelaPassageiros;
      if (tabela && typeof tabela.onSelectionInput === "function") {
        tabela.onSelectionInput([]);
      } else if (tabela) {
        tabela.selectedItems = [];
      }
    },
    sendQrCodeToSelected() {
      if (this.loadingSendQrCode) {
        return;
      }
      const lista = this.normalizePessoasSelecionadas(
        this.selectedPessoas,
      );
      this.sendQrCode(lista, { clearTableSelection: true });
    },
    buildQrCodeSendPersonLabel(pessoa) {
      if (pessoa.nome_completo) {
        return pessoa.nome_completo;
      }
      const parts = [pessoa.nome, pessoa.sobrenome].filter(Boolean);
      return parts.length > 0 ? parts.join(" ") : "N/A";
    },
    registrarResultadoEnvioQrcode(resultados, pessoa, sucesso, mensagem) {
      resultados.push({
        id_pessoa: pessoa.id_pessoa,
        nome_completo: this.buildQrCodeSendPersonLabel(pessoa),
        matricula: pessoa.badge || pessoa.matricula || "",
        email: pessoa.email || "",
        sucesso,
        mensagem,
      });
    },
    async sendQrCode(pessoas, options = {}) {
      const { clearTableSelection = false } = options;
      if (this.loadingSendQrCode) {
        return;
      }

      const lista = this.normalizePessoasSelecionadas(pessoas);
      if (lista.length === 0) {
        EventBus.$emit("show-alert", {
          tipo: "error",
          mensagem: this.$t("passengers.messages.noDataFound"),
        });
        return;
      }

      this.loadingSendQrCode = true;
      const total = lista.length;
      const batchSize = 3;
      let processadas = 0;
      let sucessos = 0;
      let erros = 0;
      const resultados = [];

      this.loadingMessage = this.$t("passengers.messages.processingBulk", {
        processadas: 0,
        total,
      });

      const enviarUma = async (pessoa) => {
        const payload = {
          email: pessoa.email,
          id_pessoa: pessoa.id_pessoa,
          qrcode_uri: pessoa.qrcode_uri,
          site: pessoa.cod_unidade,
          id_usuario: this.user.id_usuario,
        };
        if (!payload.id_pessoa) {
          processadas++;
          erros++;
          this.registrarResultadoEnvioQrcode(
            resultados,
            pessoa,
            false,
            this.$t("passengers.messages.qrCodeInvalidParams"),
          );
        } else {
          try {
            const response = await apiController.request(
              apiController.endpoints.peoplechatEnviaqrcode,
              {
                data: payload,
                silent: true,
                config: { timeout: 120000 },
              },
            );
            processadas++;
            if (response.data.erro) {
              erros++;
              this.registrarResultadoEnvioQrcode(
                resultados,
                pessoa,
                false,
                response.data.mensagem ||
                  this.$t("passengers.messages.qrCodeSendBulkAllFailed", {
                    total: 1,
                  }),
              );
            } else {
              sucessos++;
              this.registrarResultadoEnvioQrcode(
                resultados,
                pessoa,
                true,
                response.data.mensagem ||
                  this.$t("passengers.messages.qrCodeSendSuccess"),
              );
            }
          } catch (e) {
            processadas++;
            erros++;
            const mensagemErro =
              e.response?.data?.mensagem ||
              e.message ||
              this.$t("system.messages.nonIdentifiedSystemError");
            console.log("ERRO AXIOS - sendQrCode", mensagemErro);
            this.registrarResultadoEnvioQrcode(
              resultados,
              pessoa,
              false,
              mensagemErro,
            );
          }
        }
        this.loadingMessage = this.$t("passengers.messages.processingBulk", {
          processadas,
          total,
        });
      };

      const processarLote = (lote) =>
        Promise.all(lote.map((p) => enviarUma(p)));

      try {
        for (let i = 0; i < lista.length; i += batchSize) {
          const lote = lista.slice(i, i + batchSize);
          await processarLote(lote);
          if (i + batchSize < lista.length) {
            await new Promise((resolve) => setTimeout(resolve, 500));
          }
        }
      } catch (e) {
        console.log("ERRO AXIOS - sendQrCode", e);
        EventBus.$emit("show-error", { error: e });
      } finally {
        this.loadingSendQrCode = false;
        this.loadingMessage = null;
        if (clearTableSelection) {
          this.clearSelectedPessoas();
        }
      }

      this.qrCodeSendResults = resultados;
      this.qrCodeSendSummary = { total, sucessos, erros };
      this.qrCodeSendResultDialog = true;

      if (sucessos === total) {
        EventBus.$emit("show-alert", {
          tipo: "success",
          mensagem: this.$t("passengers.messages.qrCodeSendBulkAllSuccess", {
            total,
          }),
        });
        this.updateTable(false);
      } else if (sucessos > 0) {
        EventBus.$emit("show-alert", {
          tipo: "warning",
          mensagem: this.$t("passengers.messages.qrCodeSendBulkPartial", {
            sucessos,
            erros,
            total,
          }),
        });
        this.updateTable(false);
      } else {
        EventBus.$emit("show-error", {
          error: {
            message: this.$t("passengers.messages.qrCodeSendBulkAllFailed", {
              total,
            }),
          },
        });
        this.updateTable(true);
      }
    },
  },
};
</script>

<style scoped>
.foto__comum {
  padding: 10px;
  margin: 5px;
  border: 1px solid #4a4a4a;
  border-radius: 5px;
  box-shadow: #4a4a4a 1px 1px 5px;
  cursor: pointer;
}

.foto__principal {
  padding: 10px;
  margin: 5px;
  border: 2px solid #006917;
  border-radius: 5px;
  box-shadow: #006917 1px 1px 5px;
}
</style>
